// BDD
import React, { useState, useEffect, useRef, useMemo, Fragment } from "react";
import { View, Text, TextInput, ScrollView, Image, Platform, StyleSheet, useColorScheme, TouchableOpacity, Modal, FlatList } from "react-native";
import { Button, IconButton, Card } from "react-native-paper";
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { formatLocalDate } from "./Utils";
import { toInputDateTimeLocal } from "./Utils";
import { Linking } from 'react-native';

import axios from "axios";
import Hls from "hls.js";  // Γ£à Import HLS.js
import { ReactSketchCanvas } from "react-sketch-canvas"; // For Web & Windows
import WakeWordListener from "./WakeWordListener";  // Γ£à Import Wake Word Listener
// import ReactMarkdown from "react-markdown";  // Γ£à Import React Markdown Renderer
// import remarkGfm from "remark-gfm"; // Γ£à Enables GitHub Flavored Markdown (tables, lists, bold)
import "./MarkdownStyles.css";
import Markdown from 'markdown-to-jsx';
import { InlineMath, BlockMath } from 'react-katex';
// import 'katex/dist/katex.css';  // Γ£à Import KaTeX CSS
import katex from 'katex';
import 'katex/dist/katex.min.css';
import he from 'he'; // Recommended library for HTML entity decoding
import { useRoute, useNavigation  } from '@react-navigation/native';
import { useAuth } from "./AuthContext";
import { canUseTeacherTools } from "./roles";
import { useNotification } from "./NotificationContext";
import html2canvas from "html2canvas";  // Install with: npm install html2canvas
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Pressable, TouchableWithoutFeedback, Alert  } from "react-native";
import { Switch } from 'react-native';
import DateTimePicker from '@react-native-community/datetimepicker';
import { useTranslation } from "./i18n/useTranslation";
import { apiListCollections, apiGetCollectionResolved } from "./collections"; // BDD 10/23/2025 - TestPrep
// BDD 10/23/2025
import { buildCollectionTree } from "./collectionTree";
import {
  getTestDetails,
  listTestShares,
  addTestShares,
  removeTestShare,
  assignSameDomainToTest,
  publishTest,
  unpublishTest,
  parseEmailsFromText,
} from "./apiTests";
import { shareTestWithClass, getTeacherClasses  } from "./apiTests"; // BDD 12/15/2025
import { Picker } from "@react-native-picker/picker"; // BDD 12/15/2025

const languageID = 1; // TODO: Move to config in the future

import { WEBGL_BASE_URL, FASTAPI_BASE_URL, PDF_BASE_URL } from "./config";
import TestResultsSection from "./TestResultsSection";
import TeacherTestReport from "./TeacherTestReport"; // adjust path as needed
const API_URL_ASK = `${FASTAPI_BASE_URL}/ask_ai`;
const API_URL_MASTER_PLAYLIST = `${FASTAPI_BASE_URL}/master_playlist`;
const API_URL_VIDEOMETA = `${FASTAPI_BASE_URL}/video_metadata`;
const API_URL_SECURE_M3U8 = `${FASTAPI_BASE_URL}/secure_m3u8`;
const API_URL_CURRICULUM = `${FASTAPI_BASE_URL}/curriculum`;
const API_URL_CONTENT = `${FASTAPI_BASE_URL}/content`;
import TeacherTestPreview from "./TeacherTestPreview"; // BDD 10/27/2025
import SegmentsRendererRN from "./SegmentsRendererRN";

// Chip component - moved outside main component to prevent touch handler issues
function Chip({ active, label, onPress, variant = "default", isDarkMode }) {
  const dk = isDarkMode;
  const THEME_LIGHT = {
    grade:      { bg: "#eef2ff", border: "#c7d2fe", text: "#1e3a8a", dot: "#6366f1" },
    subject:    { bg: "#ecfeff", border: "#a5f3fc", text: "#155e75", dot: "#06b6d4" },
    chapter:    { bg: "#f5f3ff", border: "#ddd6fe", text: "#5b21b6", dot: "#8b5cf6" },
    topic:      { bg: "#f0fdf4", border: "#bbf7d0", text: "#166534", dot: "#22c55e" },
    collection: { bg: "#fff7ed", border: "#fed7aa", text: "#9a3412", dot: "#fb923c" },
    default:    { bg: "#f8fafc", border: "#e2e8f0", text: "#0f172a", dot: "#94a3b8" }
  };
  const THEME_DARK = {
    grade:      { bg: "rgba(99,102,241,0.15)", border: "rgba(99,102,241,0.4)", text: "#a5b4fc", dot: "#818cf8" },
    subject:    { bg: "rgba(6,182,212,0.15)", border: "rgba(6,182,212,0.4)", text: "#67e8f9", dot: "#22d3ee" },
    chapter:    { bg: "rgba(139,92,246,0.15)", border: "rgba(139,92,246,0.4)", text: "#c4b5fd", dot: "#a78bfa" },
    topic:      { bg: "rgba(34,197,94,0.15)", border: "rgba(34,197,94,0.4)", text: "#86efac", dot: "#4ade80" },
    collection: { bg: "rgba(251,146,60,0.15)", border: "rgba(251,146,60,0.4)", text: "#fdba74", dot: "#fb923c" },
    default:    { bg: "#1e293b", border: "rgba(148,163,184,0.2)", text: "#f1f5f9", dot: "#94a3b8" }
  };
  const c = (dk ? THEME_DARK : THEME_LIGHT)[variant] || (dk ? THEME_DARK : THEME_LIGHT).default;

  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        paddingVertical: 6,
        paddingHorizontal: 10,
        borderRadius: 999,
        margin: 4,
        borderWidth: 1,
        borderColor: active ? c.dot : c.border,
        backgroundColor: active ? c.bg : "transparent",
        flexDirection: "row",
        alignItems: "center"
      }}
    >
      <View
        style={{
          width: 6, height: 6, borderRadius: 3,
          backgroundColor: c.dot, marginRight: 6,
          opacity: active ? 1 : 0.8
        }}
      />
      <Text style={{ fontSize: 12, opacity: 0.95, color: c.text }}>{label}</Text>
    </TouchableOpacity>
  );
}

// Collapsible wrapper for TeacherTestReport - moved outside main component
const CollapsibleTestReport = ({ testId, isDarkMode, styles, handleSelectPastTestResultTeacher, t }) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <View style={{ marginVertical: 20 }}>
      <TouchableOpacity
        onPress={() => setCollapsed(!collapsed)}
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingVertical: 16,
          paddingHorizontal: 20,
          backgroundColor: isDarkMode ? "#334155" : "#fafaf9",
          borderRadius: 16,
          borderWidth: 1,
          borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#f3f4f6",
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.06,
          shadowRadius: 16,
          elevation: 4,
          marginBottom: collapsed ? 0 : 12,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <MaterialCommunityIcons
            name="chart-box-outline"
            size={22}
            color="#0d9488"
            style={{ marginRight: 10 }}
          />
          <Text style={{
            fontWeight: "700",
            fontSize: 16,
            color: isDarkMode ? "#f1f5f9" : "#1c1917",
            letterSpacing: 0.2,
          }}>
            {collapsed ? t("Show Test Report") : t("Hide Test Report")}
          </Text>
        </View>
        <MaterialCommunityIcons
          name={collapsed ? "chevron-down" : "chevron-up"}
          size={20}
          color="#78716c"
        />
      </TouchableOpacity>
      {!collapsed && (
        <View style={{
          marginTop: 0,
          borderRadius: 16,
          backgroundColor: isDarkMode ? "#1e293b" : "#ffffff",
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.06,
          shadowRadius: 16,
          elevation: 4,
          borderWidth: 1,
          borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#f3f4f6",
          padding: 20,
        }}>
          <TeacherTestReport
            testId={testId}
            isDarkMode={isDarkMode}
            styles={styles}
            handleSelectPastTestResultTeacher={handleSelectPastTestResultTeacher}
          />
        </View>
      )}
    </View>
  );
};

// TestDetailsForm - moved outside main component to prevent re-creation on render
const TestDetailsForm = ({
  test_id = null,
  testDetails,
  setTestDetails,
  handleSaveTest,
  showStartPicker,
  setShowStartPicker,
  showEndPicker,
  setShowEndPicker,
  isDarkMode,
  validationErrors,
  message,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  styles,
  t,
  handleSelectPastTestResultTeacher,
}) => {
  const [localTitle, setLocalTitle] = useState(testDetails.title || "");
  const [localDescription, setLocalDescription] = useState(testDetails.description || "");
  const [localDuration, setLocalDuration] = useState(testDetails.duration_minutes || "");

  useEffect(() => {
    setLocalTitle(testDetails.title || "");
    setLocalDescription(testDetails.description || "");
    setLocalDuration(testDetails.duration_minutes || "");
  }, [testDetails]);

  const updateStartTime = (date) => {
    if (!date) return;
    setTestDetails(td => ({
      ...td,
      start_time: date.toISOString()
    }));
  };

  const updateEndTime = (date) => {
    if (!date) return;
    setTestDetails(td => ({
      ...td,
      end_time: date.toISOString()
    }));
  };

  return (
    <View>
      {/* Title Field */}
      <View style={{ marginBottom: 20 }}>
        <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 8 }}>
          <MaterialCommunityIcons
            name="format-title"
            size={18}
            color="#0d9488"
            style={{ marginRight: 8 }}
          />
          <Text style={{
            fontSize: 13,
            fontWeight: "600",
            color: isDarkMode ? "#94a3b8" : "#57534e",
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}>
            {t("Test Title")}
          </Text>
        </View>
        <TextInput
          placeholder={t("Enter test title")}
          placeholderTextColor="#a8a29e"
          value={localTitle}
          onChangeText={setLocalTitle}
          onBlur={() => setTestDetails({ ...testDetails, title: localTitle })}
          style={{
            borderWidth: 1,
            borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e5e7eb",
            borderRadius: 10,
            padding: 14,
            fontSize: 15,
            color: isDarkMode ? "#f1f5f9" : "#1c1917",
            backgroundColor: isDarkMode ? "#334155" : "#ffffff",
            fontWeight: "500",
          }}
        />
        {validationErrors.title && (
          <Text style={{
            color: "#dc2626",
            fontSize: 12,
            marginTop: 6,
            fontWeight: "500",
          }}>
            {validationErrors.title}
          </Text>
        )}
      </View>

      {/* Description Field */}
      <View style={{ marginBottom: 20 }}>
        <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 8 }}>
          <MaterialCommunityIcons
            name="text"
            size={18}
            color="#0d9488"
            style={{ marginRight: 8 }}
          />
          <Text style={{
            fontSize: 13,
            fontWeight: "600",
            color: isDarkMode ? "#94a3b8" : "#57534e",
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}>
            {t("Description")}
          </Text>
        </View>
        <TextInput
          placeholder={t("Enter test description")}
          placeholderTextColor="#a8a29e"
          value={localDescription}
          onChangeText={setLocalDescription}
          onBlur={() => setTestDetails({ ...testDetails, description: localDescription })}
          style={{
            borderWidth: 1,
            borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e5e7eb",
            borderRadius: 10,
            padding: 14,
            fontSize: 15,
            color: isDarkMode ? "#f1f5f9" : "#1c1917",
            backgroundColor: isDarkMode ? "#334155" : "#ffffff",
          }}
        />
      </View>

      {/* Start Time */}
      <View style={{ marginBottom: 20 }}>
        <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 8 }}>
          <MaterialCommunityIcons
            name="calendar-start"
            size={18}
            color="#0d9488"
            style={{ marginRight: 8 }}
          />
          <Text style={{
            fontSize: 13,
            fontWeight: "600",
            color: isDarkMode ? "#94a3b8" : "#57534e",
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}>
            {t("Start Time")}
          </Text>
        </View>
        {Platform.OS === "web" ? (
          <input
            type="datetime-local"
            value={toInputDateTimeLocal(testDetails.start_time)}
            onChange={(e) => {
              const newDate = new Date(e.target.value);
              updateStartTime(newDate);
            }}
            style={{
              border: isDarkMode ? "1px solid rgba(148,163,184,0.15)" : "1px solid #e5e7eb",
              borderRadius: "10px",
              padding: "14px",
              fontSize: "15px",
              color: isDarkMode ? "#f1f5f9" : "#1c1917",
              backgroundColor: isDarkMode ? "#334155" : "#ffffff",
              width: "98%",
              fontFamily: "system-ui, -apple-system",
            }}
          />
        ) : (
          <>
            <TouchableOpacity
              onPress={() => setShowStartPicker(true)}
              style={{
                borderWidth: 1,
                borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e5e7eb",
                borderRadius: 10,
                padding: 14,
                backgroundColor: isDarkMode ? "#334155" : "#ffffff",
              }}
            >
              <Text style={{ fontSize: 15, color: isDarkMode ? "#f1f5f9" : "#1c1917" }}>
                {testDetails.start_time
                  ? formatLocalDate(testDetails.start_time)
                  : t("Select start time")}
              </Text>
            </TouchableOpacity>
            {showStartPicker && (
              <DateTimePicker
                value={startDate}
                mode="datetime"
                display="default"
                onChange={(event, selectedDate) => {
                  setShowStartPicker(false)
                  if (selectedDate) {
                    setStartDate(selectedDate)
                    updateStartTime(selectedDate)
                  }
                }}
              />
            )}
          </>
        )}
        {validationErrors.schedule && (
          <Text style={{
            color: "#dc2626",
            fontSize: 12,
            marginTop: 6,
            fontWeight: "500",
          }}>
            {validationErrors.schedule}
          </Text>
        )}
      </View>

      {/* End Time */}
      <View style={{ marginBottom: 20 }}>
        <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 8 }}>
          <MaterialCommunityIcons
            name="calendar-end"
            size={18}
            color="#0d9488"
            style={{ marginRight: 8 }}
          />
          <Text style={{
            fontSize: 13,
            fontWeight: "600",
            color: isDarkMode ? "#94a3b8" : "#57534e",
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}>
            {t("End Time")}
          </Text>
        </View>
        {Platform.OS === "web" ? (
          <input
            type="datetime-local"
            value={toInputDateTimeLocal(testDetails.end_time)}
            onChange={(e) => {
              const newDate = new Date(e.target.value);
              updateEndTime(newDate);
            }}
            style={{
              border: isDarkMode ? "1px solid rgba(148,163,184,0.15)" : "1px solid #e5e7eb",
              borderRadius: "10px",
              padding: "14px",
              fontSize: "15px",
              color: isDarkMode ? "#f1f5f9" : "#1c1917",
              backgroundColor: isDarkMode ? "#334155" : "#ffffff",
              width: "98%",
              fontFamily: "system-ui, -apple-system",
            }}
          />
        ) : (
          <>
            <TouchableOpacity
              onPress={() => setShowEndPicker(true)}
              style={{
                borderWidth: 1,
                borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e5e7eb",
                borderRadius: 10,
                padding: 14,
                backgroundColor: isDarkMode ? "#334155" : "#ffffff",
              }}
            >
              <Text style={{ fontSize: 15, color: isDarkMode ? "#f1f5f9" : "#1c1917" }}>
                {testDetails.end_time
                  ? formatLocalDate(testDetails.end_time)
                  : t("Select end time")}
              </Text>
            </TouchableOpacity>
            {showEndPicker && (
              <DateTimePicker
                value={endDate}
                mode="datetime"
                display="default"
                onChange={(event, selectedDate) => {
                  setShowEndPicker(false);
                  if (selectedDate) {
                    setEndDate(selectedDate);
                    updateEndTime(selectedDate);
                  }
                }}
              />
            )}
          </>
        )}
      </View>

      {/* Duration Field */}
      <View style={{ marginBottom: 20 }}>
        <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 8 }}>
          <MaterialCommunityIcons
            name="timer-outline"
            size={18}
            color="#0d9488"
            style={{ marginRight: 8 }}
          />
          <Text style={{
            fontSize: 13,
            fontWeight: "600",
            color: isDarkMode ? "#94a3b8" : "#57534e",
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}>
            {t("Duration (minutes)")}
          </Text>
        </View>
        <TextInput
          placeholder={t("Enter duration in minutes")}
          placeholderTextColor="#a8a29e"
          value={localDuration}
          onChangeText={setLocalDuration}
          onBlur={() => setTestDetails({ ...testDetails, duration_minutes: localDuration })}
          style={{
            borderWidth: 1,
            borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e5e7eb",
            borderRadius: 10,
            padding: 14,
            fontSize: 15,
            color: isDarkMode ? "#f1f5f9" : "#1c1917",
            backgroundColor: isDarkMode ? "#334155" : "#ffffff",
          }}
          keyboardType="numeric"
        />
        {validationErrors.duration && (
          <Text style={{
            color: "#dc2626",
            fontSize: 12,
            marginTop: 6,
            fontWeight: "500",
          }}>
            {validationErrors.duration}
          </Text>
        )}
      </View>

      {/* Chapter/Question Errors */}
      {validationErrors.chapters && (
        <View style={{
          padding: 12,
          backgroundColor: "#fef2f2",
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#fecaca",
          marginBottom: 16,
        }}>
          <Text style={{ color: "#dc2626", fontSize: 13, fontWeight: "500" }}>
            {validationErrors.chapters}
          </Text>
        </View>
      )}
      {validationErrors.questions && (
        <View style={{
          padding: 12,
          backgroundColor: "#fef2f2",
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#fecaca",
          marginBottom: 16,
        }}>
          <Text style={{ color: "#dc2626", fontSize: 13, fontWeight: "500" }}>
            {validationErrors.questions}
          </Text>
        </View>
      )}

      {/* General error message */}
      {message !== "" && (
        <View style={{
          padding: 12,
          backgroundColor: "#fef2f2",
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#fecaca",
          marginBottom: 16,
        }}>
          <Text style={{ color: "#dc2626", fontSize: 13, fontWeight: "500" }}>
            {message}
          </Text>
        </View>
      )}

      {/* Save Button */}
      <TouchableOpacity
        onPress={handleSaveTest}
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          paddingVertical: 14,
          paddingHorizontal: 24,
          borderRadius: 12,
          backgroundColor: "#0d9488",
          shadowColor: "#0d9488",
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.3,
          shadowRadius: 8,
          elevation: 4,
          marginBottom: 16,
        }}
      >
        <MaterialCommunityIcons
          name="content-save"
          size={20}
          color="#ffffff"
          style={{ marginRight: 8 }}
        />
        <Text style={{
          color: "#ffffff",
          fontWeight: "700",
          fontSize: 16,
          letterSpacing: 0.3,
        }}>
          {t("Save Test")}
        </Text>
      </TouchableOpacity>

      {/* If the active test is published and teacher is logged in, show the test report */}
      {testDetails.is_published && test_id && (
        <CollapsibleTestReport
          testId={test_id}
          isDarkMode={isDarkMode}
          styles={styles}
          handleSelectPastTestResultTeacher={handleSelectPastTestResultTeacher}
          t={t}
        />
      )}
    </View>
  );
};

// VisibilityPill component - moved outside to prevent re-creation
function VisibilityPill({ visLocal }) {
  const labelMap = {
    private: "Private",
    org: "School/Org",
    public: "Public",
  };
  const colorMap = {
    private: { bg: "#fef3f2", border: "#f79481", text: "#991b1b" },
    org: { bg: "#ecfdf5", border: "#6ee7b7", text: "#065f46" },
    public: { bg: "#f0f9ff", border: "#7dd3fc", text: "#075985" },
  };
  const colors = colorMap[visLocal] || colorMap.private;

  return (
    <View
      style={{
        paddingVertical: 4,
        paddingHorizontal: 12,
        borderRadius: 20,
        borderWidth: 1.5,
        borderColor: colors.border,
        backgroundColor: colors.bg,
      }}
    >
      <Text style={{
        fontSize: 12,
        fontWeight: "600",
        color: colors.text,
        letterSpacing: 0.3,
      }}>
        {labelMap[visLocal] || visLocal}
      </Text>
    </View>
  );
}

// VisibilityOption component - moved outside to prevent re-creation
function VisibilityOption({ value, icon, label, description, visLocal, changeVisibility }) {
  const isSelected = visLocal === value;
  return (
    <TouchableOpacity
      onPress={() => changeVisibility(value)}
      style={{
        flex: 1,
        minWidth: 140,
        padding: 16,
        borderRadius: 12,
        borderWidth: 2,
        marginRight: 12,
        marginBottom: 12,
        borderColor: isSelected ? "#0d9488" : "#e5e7eb",
        backgroundColor: isSelected ? "#f0fdfa" : "#ffffff",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: isSelected ? 0.08 : 0.03,
        shadowRadius: 8,
        elevation: isSelected ? 3 : 1,
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 6 }}>
        <MaterialCommunityIcons
          name={icon}
          size={20}
          color={isSelected ? "#0d9488" : "#6b7280"}
          style={{ marginRight: 8 }}
        />
        <Text style={{
          fontSize: 14,
          fontWeight: "600",
          color: isSelected ? "#0d9488" : "#374151",
        }}>
          {label}
        </Text>
      </View>
      <Text style={{
        fontSize: 12,
        color: "#6b7280",
        lineHeight: 16,
      }}>
        {description}
      </Text>
    </TouchableOpacity>
  );
}

// PublishShareTestCard - moved outside main component
function PublishShareTestCard({ testId, isPublished, onChangePublished, selectedClassId, setSelectedClassId, teacherClasses, shareTestWithClass, expanded, setExpanded, showNotification, fetchWithAuth, t }) {
  const [visLocal, setVisLocal] = useState(isPublished ? "org" : "private");
  const [shares, setShares] = useState([]);
  const [sharedClasses, setSharedClasses] = useState([]);
  const [shareInput, setShareInput] = useState("");
  const [isSavingShare, setIsSavingShare] = useState(false);
  const [publishingBusy, setPublishingBusy] = useState(false);

  const infoAlert = (title, msg) => {
    if (Platform?.OS === "web" && typeof window !== "undefined") {
      window.alert(`${title}\n\n${msg || ""}`);
    } else {
      Alert.alert(title, msg);
    }
  };

  useEffect(() => {
    if (!testId) return;
    let ignore = false;

    (async function loadScope() {
      try {
        const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}`);
        const data = await res.json();
        const t = data?.test || {};

        const scopeFromServer = t.is_published
          ? (t.published_scope || "org")
          : "private";

        if (!ignore) {
          setVisLocal(scopeFromServer);

          if (
            typeof onChangePublished === "function" &&
            (!!isPublished !== !!t.is_published)
          ) {
            onChangePublished(!!t.is_published);
          }
        }
      } catch (e) {
        if (!ignore) {
          setVisLocal(isPublished ? "org" : "private");
        }
      }
    })();

    return () => {
      ignore = true;
    };
  }, [testId, fetchWithAuth]);

  useEffect(() => {
    if (testId) {
      listShares();
      listSharedClasses();
    }
  }, [testId]);

  function parseEmails(text) {
    const tokens = String(text || "").replace(/\r/g, "\n").split(/[\s,;]+/);
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const seen = new Set();
    const out = [];
    for (const tok of tokens) {
      const e = tok.trim().toLowerCase();
      if (e && re.test(e) && !seen.has(e)) {
        seen.add(e);
        out.push(e);
      }
    }
    return out;
  }

  async function listShares() {
    try {
      const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shares`);
      const data = await res.json();
      setShares(Array.isArray(data) ? data : []);
    } catch (e) {
      console.warn("listShares failed", e);
      setShares([]);
    }
  }

  async function addShares() {
    const emails = parseEmails(shareInput);
    if (!emails.length) return;
    setIsSavingShare(true);
    try {
      const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_emails: emails }),
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        const detail = errData?.detail || `Server error (${res.status})`;
        infoAlert("Error", `Could not add students: ${detail}`);
        return;
      }
      setShareInput("");
      await listShares();
    } catch (e) {
      infoAlert("Error", "Could not add students.");
    } finally {
      setIsSavingShare(false);
    }
  }

  async function revokeShare(email) {
    try {
      await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_email: email }),
      });
      setShares((prev) => prev.filter((s) => s.student_email !== email));
    } catch (e) {
      infoAlert("Error", "Could not remove student.");
    }
  }

  async function listSharedClasses() {
    try {
      const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shared_classes`);
      const data = await res.json();
      setSharedClasses(Array.isArray(data) ? data : []);
    } catch (e) {
      console.warn("listSharedClasses failed", e);
      setSharedClasses([]);
    }
  }

  async function removeClassShare(classId) {
    try {
      await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shared_classes/${classId}`, {
        method: "DELETE",
      });
      setSharedClasses((prev) => prev.filter((c) => c.class_id !== classId));
      showNotification("Class removed from sharing", "success");
    } catch (e) {
      infoAlert("Error", "Could not remove class share.");
    }
  }

  async function assignSameDomain() {
    try {
      setIsSavingShare(true);
      await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/assign_same_domain`, {
        method: "POST",
      });
      setVisLocal("org");
      await listShares();
    } catch (e) {
      infoAlert("Error", "Could not share with your school domain.");
    } finally {
      setIsSavingShare(false);
    }
  }

  function changeVisibility(next) {
    setVisLocal(next);
  }

  async function handleTogglePublish(nextIsPublished) {
    if (publishingBusy) return;
    if (!testId) return;

    const prevPublished = !!isPublished;
    const prevScope = visLocal;

    onChangePublished?.(nextIsPublished);

    setPublishingBusy(true);
    try {
      if (nextIsPublished) {
        await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/publish`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            scope: visLocal === "private" ? "org" : visLocal,
          }),
        });
      } else {
        await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/unpublish`, {
          method: "POST",
        });
      }
    } catch (e) {
      onChangePublished?.(prevPublished);
      setVisLocal(prevScope);
      infoAlert(
        "Error",
        "Could not update published status. Please try again."
      );
    } finally {
      setPublishingBusy(false);
    }
  }

  async function handleCsvFileChange(evt) {
    try {
      const file = evt.target?.files?.[0];
      if (!file) return;
      setIsSavingShare(true);

      const text = await file.text();
      const emails = parseEmails(text);
      if (!emails.length) {
        infoAlert("CSV", "No emails found.");
        return;
      }

      await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_emails: emails }),
      });

      await listShares();
    } catch (e) {
      infoAlert("Error", "Could not process CSV.");
    } finally {
      setIsSavingShare(false);
      if (evt?.target) evt.target.value = "";
    }
  }

  return (
    <View style={{
      borderRadius: 16,
      borderWidth: 1,
      borderColor: "#f3f4f6",
      backgroundColor: "#ffffff",
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.06,
      shadowRadius: 16,
      elevation: 4,
      overflow: "hidden",
    }}>
      <TouchableOpacity
        onPress={() => setExpanded(!expanded)}
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingVertical: 16,
          paddingHorizontal: 20,
          backgroundColor: "#fafaf9",
          borderBottomWidth: expanded ? 1 : 0,
          borderBottomColor: "#e7e5e4",
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <MaterialCommunityIcons
            name="share-variant"
            size={22}
            color="#0d9488"
            style={{ marginRight: 10 }}
          />
          <Text style={{
            fontWeight: "700",
            fontSize: 16,
            color: "#1c1917",
            letterSpacing: 0.2,
          }}>
            {t("Publish & Share Test")}
          </Text>
          <View style={{ marginLeft: 12 }}>
            <VisibilityPill visLocal={visLocal} />
          </View>
        </View>
        <MaterialCommunityIcons
          name={expanded ? "chevron-up" : "chevron-down"}
          size={20}
          color="#78716c"
        />
      </TouchableOpacity>

      {expanded && (
        <View style={{ padding: 20 }}>
          {/* Visibility Options */}
          <View style={{ marginBottom: 24 }}>
            <Text style={{
              fontSize: 13,
              fontWeight: "600",
              color: "#57534e",
              textTransform: "uppercase",
              letterSpacing: 0.8,
              marginBottom: 12,
            }}>
              Visibility
            </Text>
            <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
              <VisibilityOption
                value="private"
                icon="lock"
                label="Private"
                description="Only you can see this test"
                visLocal={visLocal}
                changeVisibility={changeVisibility}
              />
              <VisibilityOption
                value="org"
                icon="office-building"
                label="School/Org"
                description="Anyone in your school can access"
                visLocal={visLocal}
                changeVisibility={changeVisibility}
              />
              <VisibilityOption
                value="public"
                icon="earth"
                label="Public"
                description="Anyone with the link can access"
                visLocal={visLocal}
                changeVisibility={changeVisibility}
              />
            </View>
          </View>

          {/* Share with Specific Students */}
          <View style={{ marginBottom: 24 }}>
            <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 12 }}>
              <MaterialCommunityIcons
                name="account-plus-outline"
                size={18}
                color="#0d9488"
                style={{ marginRight: 8 }}
              />
              <Text style={{
                fontSize: 13,
                fontWeight: "600",
                color: "#57534e",
                textTransform: "uppercase",
                letterSpacing: 0.8,
              }}>
                Share with Specific Students
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 8, marginBottom: 12 }}>
              <TextInput
                placeholder="Enter email addresses..."
                placeholderTextColor="#a8a29e"
                value={shareInput}
                onChangeText={setShareInput}
                style={{
                  flex: 1,
                  borderWidth: 1,
                  borderColor: "#e5e7eb",
                  borderRadius: 10,
                  padding: 12,
                  fontSize: 14,
                  color: "#1c1917",
                  backgroundColor: "#ffffff",
                }}
              />
              <TouchableOpacity
                onPress={addShares}
                disabled={isSavingShare}
                style={{
                  paddingVertical: 12,
                  paddingHorizontal: 18,
                  borderRadius: 10,
                  backgroundColor: isSavingShare ? "#d1d5db" : "#0d9488",
                  shadowColor: "#0d9488",
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.15,
                  shadowRadius: 4,
                  elevation: 2,
                }}
              >
                <Text style={{ color: "#ffffff", fontWeight: "600", fontSize: 14 }}>
                  {isSavingShare ? "Adding..." : "Add"}
                </Text>
              </TouchableOpacity>
            </View>

            {/* CSV Upload & Same Domain */}
            <View style={{ flexDirection: "row", gap: 8, marginBottom: 12 }}>
              {Platform.OS === "web" && (
                <TouchableOpacity
                  onPress={() => document.getElementById(`csv-input-${testId}`)?.click()}
                  style={{
                    flex: 1,
                    paddingVertical: 10,
                    paddingHorizontal: 14,
                    borderRadius: 8,
                    backgroundColor: "#f0fdfa",
                    borderWidth: 1,
                    borderColor: "#99f6e4",
                  }}
                >
                  <Text style={{ fontSize: 13, fontWeight: "600", color: "#0d9488", textAlign: "center" }}>
                    Upload CSV
                  </Text>
                  <input
                    id={`csv-input-${testId}`}
                    type="file"
                    accept=".csv"
                    style={{ display: "none" }}
                    onChange={handleCsvFileChange}
                  />
                </TouchableOpacity>
              )}
              <TouchableOpacity
                onPress={assignSameDomain}
                disabled={isSavingShare}
                style={{
                  flex: 1,
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  borderRadius: 8,
                  backgroundColor: "#f0fdfa",
                  borderWidth: 1,
                  borderColor: "#99f6e4",
                }}
              >
                <Text style={{ fontSize: 13, fontWeight: "600", color: "#0d9488", textAlign: "center" }}>
                  {isSavingShare ? "Sharing..." : "Share with School"}
                </Text>
              </TouchableOpacity>
            </View>
          </View>

          {/* Share with Class */}
          <View style={{ marginBottom: 24 }}>
            <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 12 }}>
              <MaterialCommunityIcons
                name="google-classroom"
                size={18}
                color="#0d9488"
                style={{ marginRight: 8 }}
              />
              <Text style={{
                fontSize: 13,
                fontWeight: "600",
                color: "#57534e",
                textTransform: "uppercase",
                letterSpacing: 0.8,
              }}>
                Share with Class
              </Text>
            </View>

            <Picker
              selectedValue={selectedClassId}
              onValueChange={(itemValue) => setSelectedClassId(itemValue)}
              style={{
                borderWidth: 1,
                borderColor: "#e5e7eb",
                borderRadius: 10,
                backgroundColor: "#ffffff",
                padding: 10,
              }}
            >
              <Picker.Item label="Select a class" value={null} />
              {teacherClasses.map((cls) => (
                <Picker.Item key={cls.id} label={`${cls.name} (${cls.school})`} value={cls.id} />
              ))}
            </Picker>

            <TouchableOpacity
              onPress={async () => {
                if (!selectedClassId) return showNotification("Please select a class first.", "warning");
                try {
                  await shareTestWithClass(testId, selectedClassId);
                  showNotification("Test shared with class successfully!", "success");
                  await listSharedClasses(); // Refresh the list
                } catch (e) {
                  console.error(e);
                  showNotification("Could not share test with class.", "error");
                }
              }}
              style={{
                marginTop: 12,
                paddingVertical: 10,
                paddingHorizontal: 18,
                borderRadius: 10,
                backgroundColor: "#0d9488",
                shadowColor: "#0d9488",
                shadowOffset: { width: 0, height: 3 },
                shadowOpacity: 0.2,
                shadowRadius: 6,
                elevation: 3,
              }}
            >
              <Text style={{
                color: "#ffffff",
                fontWeight: "600",
                fontSize: 14,
                textAlign: "center",
              }}>
                Share with Selected Class
              </Text>
            </TouchableOpacity>
          </View>

          {/* Shared Students List */}
          {!!shares.length && (
            <View style={{
              marginBottom: 24,
              padding: 18,
              backgroundColor: "#fafaf9",
              borderRadius: 12,
              borderWidth: 1,
              borderColor: "#e7e5e4",
            }}>
              <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 12 }}>
                <MaterialCommunityIcons
                  name="account-multiple-outline"
                  size={18}
                  color="#0d9488"
                  style={{ marginRight: 8 }}
                />
                <Text style={{
                  fontSize: 13,
                  fontWeight: "600",
                  color: "#57534e",
                  textTransform: "uppercase",
                  letterSpacing: 0.8,
                }}>
                  Shared With ({shares.length})
                </Text>
              </View>
              {shares.map((s, idx) => (
                <View
                  key={s.student_email}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingVertical: 10,
                    borderBottomWidth: idx < shares.length - 1 ? 1 : 0,
                    borderBottomColor: "#e7e5e4",
                  }}
                >
                  <Text style={{ fontSize: 13, color: "#1c1917", flex: 1 }}>
                    {s.student_email}
                  </Text>
                  <TouchableOpacity
                    onPress={() => revokeShare(s.student_email)}
                    style={{
                      paddingVertical: 4,
                      paddingHorizontal: 10,
                      borderRadius: 6,
                      backgroundColor: "#fef2f2",
                      borderWidth: 1,
                      borderColor: "#fecaca",
                    }}
                  >
                    <Text style={{ fontSize: 12, color: "#dc2626", fontWeight: "600" }}>
                      Remove
                    </Text>
                  </TouchableOpacity>
                </View>
              ))}
            </View>
          )}

          {/* Shared Classes List */}
          {!!sharedClasses.length && (
            <View style={{
              marginBottom: 24,
              padding: 18,
              backgroundColor: "#f0fdf4",
              borderRadius: 12,
              borderWidth: 1,
              borderColor: "#bbf7d0",
            }}>
              <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 12 }}>
                <MaterialCommunityIcons
                  name="google-classroom"
                  size={18}
                  color="#0d9488"
                  style={{ marginRight: 8 }}
                />
                <Text style={{
                  fontSize: 13,
                  fontWeight: "600",
                  color: "#57534e",
                  textTransform: "uppercase",
                  letterSpacing: 0.8,
                }}>
                  Shared with Classes ({sharedClasses.length})
                </Text>
              </View>
              {sharedClasses.map((c, idx) => (
                <View
                  key={c.class_id}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingVertical: 10,
                    borderBottomWidth: idx < sharedClasses.length - 1 ? 1 : 0,
                    borderBottomColor: "#dcfce7",
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontSize: 13, color: "#1c1917", fontWeight: "600" }}>
                      {c.class_name}
                    </Text>
                    <Text style={{ fontSize: 11, color: "#78716c", marginTop: 2 }}>
                      {c.school_name}
                    </Text>
                  </View>
                  <TouchableOpacity
                    onPress={() => removeClassShare(c.class_id)}
                    style={{
                      paddingVertical: 4,
                      paddingHorizontal: 10,
                      borderRadius: 6,
                      backgroundColor: "#fef2f2",
                      borderWidth: 1,
                      borderColor: "#fecaca",
                    }}
                  >
                    <Text style={{ fontSize: 12, color: "#dc2626", fontWeight: "600" }}>
                      Remove
                    </Text>
                  </TouchableOpacity>
                </View>
              ))}
            </View>
          )}

          {/* Publish Toggle */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingVertical: 18,
              paddingHorizontal: 20,
              borderRadius: 12,
              backgroundColor: isPublished ? "#ecfdf5" : "#fafaf9",
              borderWidth: 2,
              borderColor: isPublished ? "#6ee7b7" : "#e7e5e4",
              justifyContent: "space-between",
            }}
          >
            <View>
              <Text style={{
                fontSize: 15,
                fontWeight: "700",
                color: "#1c1917",
                marginBottom: 4,
              }}>
                {isPublished ? "Test is Published" : "Publish Test?"}
              </Text>
              <Text style={{
                fontSize: 12,
                color: "#78716c",
              }}>
                {isPublished
                  ? "Students can now access this test"
                  : "Make this test available to students"}
              </Text>
            </View>

            <Switch
              value={!!isPublished}
              disabled={publishingBusy}
              onValueChange={(nextVal) => handleTogglePublish(nextVal)}
              trackColor={{ false: "#94a3b8", true: "#6ee7b7" }}
              thumbColor={isPublished ? "#10b981" : "#e2e8f0"}
            />
          </View>
        </View>
      )}
    </View>
  );
}

const CreateTestQuestionsPageNew2 = ({ isDarkMode: isDarkModeProp }) => {
  // Use prop if provided, otherwise fall back to system color scheme
  const colorScheme = useColorScheme();
  const isDarkMode = isDarkModeProp !== undefined ? isDarkModeProp : (colorScheme === "dark");
  const { showNotification } = useNotification();

  const [history, setHistory] = useState([]);
  const [answer, setAnswer] = useState("");
  const [documents, setDocuments] = useState([]);
  const [videos, setVideos] = useState([]);
  const [pwos, setPwos] = useState([]);
  const [showBanner, setShowBanner] = useState(false);  // State for showing the banner for pwo

  const [loading, setLoading] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showPwo, setShowPwo] = useState(false);

  const videoRef = useRef(null);  // Γ£à Video ref for attaching HLS.js
  const pwoRef = useRef(null);
  const whiteboardRef = useRef(null);

  const [videoDuration, setVideoDuration] = useState(null);
  const [secureVideoUrl, setSecureVideoUrl] = useState("");

  const [activeModule, setActiveModule] = useState(null); // "question", "video", "pwo", "whiteboard", "uploaded", "quiz", "teacherDashboard"
  const [currentVideoId, setCurrentVideoId] = useState(null);
  const [currentVideoTagID, setCurrentVideoTagID] = useState(null);
  const [currentPwoId, setCurrentPwoId] = useState(null);
  const [currentPwoScene, setCurrentPwoScene] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedResponse, setUploadedResponse] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [isNewDialog, setIsNewDialog] = useState(false);  // Tracks new chat state
  const [includeReference, setIncludeReference] = useState(true);
  const [loadingDots, setLoadingDots] = useState(0);
  const [isMuted, setIsMuted] = useState(false);

  const [question, setQuestion] = useState("");
  const [inputValue, setInputValue] = useState(""); // Local state for input box
  const [isVoiceInput, setIsVoiceInput] = useState(false);  // Tracks voice input

// Add these state variables to your component
const [activeSidebarTab, setActiveSidebarTab] = useState('learning'); // 'history' or 'learning'

// States for learning path expansion
const [expandedSubjects, setExpandedSubjects] = useState({});
const [expandedChapters, setExpandedChapters] = useState({});
const [expandedTopics, setExpandedTopics] = useState({});
// Track expansion state for Videos and PWOs separately inside topics
const [expandedVideos, setExpandedVideos] = useState({});
const [expandedPWOs, setExpandedPWOs] = useState({});

const [curriculum, setCurriculum] = useState([]);
// const [quizData, setQuiz] = useState({}); // Store fetched quiz data
const [quiz, setQuiz] = useState([]); // complete list to render (existing + new)
const [existingTestQuestions, setExistingTestQuestions] = useState([]);
const [autoSelectCount, setAutoSelectCount] = useState("");

// State for storing user answers
const [userAnswers, setUserAnswers] = useState({});
const [answerFeedback, setAnswerFeedback] = useState({});
const [showHints, setShowHints] = useState({});
const [showSolutions, setShowSolutions] = useState({});
// At the top of your component with other state definitions:
const [validationErrors, setValidationErrors] = useState({});

const [assessments, setAssessments] = useState([]);
const [engagementLogs, setEngagementLogs] = useState([]);
const [quizResponses, setQuizResponses] = useState({}); // Stores correct/wrong/unattempted answers
const [totalQuestions, setTotalQuestions] = useState(10); // Adjust dynamically if needed
const [attemptedQuestions, setAttemptedQuestions] = useState([]);;
const [assessmentId, setAssessmentId] = useState(null);
const [activeVideo, setActiveVideo] = useState(null);
const [activePWO, setActivePWO] = useState(null);
const [activeTopic, setActiveTopic] = useState(null);
const pwoIframeRef = useRef(null);



const [aiNudge, setAiNudge] = useState("");
const [adaptiveRecommendation, setAdaptiveRecommendation] = useState("");

const [leaderboard, setLeaderboard] = useState([]);
const [badges, setBadges] = useState([]);

const [clickCount, setClickCount] = useState(0);
const [quizAttempts, setQuizAttempts] = useState(0);
const clickCountRef = useRef(0);
const quizAttemptsRef = useRef(0);
const navigation = useNavigation();
const [selectedTestId, setSelectedTestId] = useState(null);

const [profileModalVisible, setProfileModalVisible] = useState(false);
const [profileData, setProfileData] = useState({
    grade: "",
    age: "",
    passion: "",
    favorite_stem_subject: "",
    extracurricular_activity: "",
    preferred_learning_style: "",
});
const { selectedSecondaryLang } = useAuth(); 
// normalize “auto” → “en”
const langCode = selectedSecondaryLang === "auto"
    ? "en"
    : selectedSecondaryLang;

// map 2-letter codes to your quiz DB language_id
const quizLanguageMap = {
    en: 1,
    pt: 3,
    te: 4,
    // add others in future…
  };
// const [aiGrade, setAiGrade] = useState(7);
// const [aiDifficulty, setAiDifficulty] = useState("medium");
// const [aiCountMCQ, setAiCountMCQ] = useState(3);
// const [aiCountFill, setAiCountFill] = useState(2);
// const [aiCountAssoc, setAiCountAssoc] = useState(2);
// const [aiCountShortEssay, setAiCountShortEssay] = useState(2);
// const [aiCountLongEssay, setAiCountLongEssay] = useState(2);
// BDD 12/15/2025
const [aiGrade, setAiGrade] = useState("");
const [aiDifficulty, setAiDifficulty] = useState("");
const [aiCountMCQ, setAiCountMCQ] = useState("");
const [aiCountFill, setAiCountFill] = useState("");
const [aiCountAssoc, setAiCountAssoc] = useState("");
const [aiCountShortEssay, setAiCountShortEssay] = useState("");
const [aiCountLongEssay, setAiCountLongEssay] = useState("");

const [aiInstructions, setAiInstructions] = useState("");

// default to English (1) if nothing matches
const languageIDquiz = quizLanguageMap[langCode] ?? 1;

// Inside your component...
const webglReadyHandlerRef = useRef(null);
const unauthorizedHandlerRef = useRef(null);
const [selectedQuestionIds, setSelectedQuestionIds] = useState(new Set());
const [selectedQuestionObjects, setSelectedQuestionObjects] = useState([]);
// States for test management
const [tests, setTests] = useState([]);
const [selectedTest, setSelectedTest] = useState(null); // currently selected test
// Instead of storing start_time/end_time as strings, store as Date objects:
const [testDetails, setTestDetails] = useState({
    title: "",
    description: "",
    chapters: [],
    start_time: "",   // will hold ISO string, e.g. "2025-04-17T16:30:00.000Z"
    end_time: "",     // same here
    // start_time: new Date(), // initial start time
    // end_time: new Date(),   // initial end time
    duration_minutes: "",   // Keep as string for TextInput, then parse to number on save
    is_published: false,
  });
  // Store the date objects in state
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  // Control the visibility of each picker
  const [showStartPicker, setShowStartPicker] = useState(false);
  const [showEndPicker, setShowEndPicker] = useState(false);
  const { t } = useTranslation();

  const onStartDateChange = (e, selected) => {
    setShowStartPicker(false);
    if (selected) {
      setStartDate(selected);
      setTestDetails(td => ({
        ...td,
        start_time: selected.toISOString()
      }));
    }
  };
  
  const onEndDateChange = (e, selected) => {
    setShowEndPicker(false);
    if (selected) {
      setEndDate(selected);
      setTestDetails(td => ({
        ...td,
        end_time: selected.toISOString()
      }));
    }
  };
const [showTestDetails, setShowTestDetails] = useState(true);

const auth = useAuth();  // ✅ Get token inside the component

if (!auth) {
    console.error("⚠️ AuthContext is missing! Ensure AuthProvider wraps the app.");
    return <Text>⚠️ {t("Error: Authentication context is missing!")}</Text>;
}

const { authToken, user, logout, fetchWithAuth } = auth;
const user_id = user ? user.email : "Guest";
// console.log("User ID:", user_id);
// console.log("Auth Token:", authToken);
// 🔹 Expanded Language List (OpenAI + Gujarati + Telugu)
const languages = [
    { id: "auto", name: "Auto Detect" },
    // { id: "en-US", name: "English-USA" },
    // { id: "en-IN", name: "English-India" },
    { id: "en", name: "English" },
    { id: "es", name: "Spanish" },
    { id: "hi", name: "Hindi" },
    { id: "fr", name: "French" },
    { id: "zh", name: "Chinese (Simplified)" },
    { id: "ja", name: "Japanese" },
    { id: "ko", name: "Korean" },
    { id: "de", name: "German" },
    { id: "it", name: "Italian" },
    { id: "ru", name: "Russian" },
    { id: "ar", name: "Arabic" },
    { id: "gu", name: "Gujarati" },  // ✅ Added
    { id: "te", name: "Telugu" },  // ✅ Added
    { id: "mr", name: "Marathi" },  // ✅ Added
    // { id: "pt-BR", name: "Portuguese-Brazil" }, // ✅ Added
    // { id: "pt-PT", name: "Portuguese-Portugal" }  // ✅ Added
    { id: "pt", name: "Portuguese" }  // ✅ Added
];
const [menuVisible, setMenuVisible] = useState(false);
const [languageModal, setLanguageModal] = useState(false);
const [selectedPrimaryLang, setSelectedPrimaryLang] = useState("auto");
// const [selectedSecondaryLang, setSelectedSecondaryLang] = useState("auto");
// inside the CreateTestQuestionsPageNew2 component:

const [selectedTopics, setSelectedTopics] = useState(new Set());

 const toggleTopicSelection = (chapterId, topicId) => {
  const key = `${chapterId}-${topicId}`;
  setSelectedTopics((prev) => {
    const newSet = new Set(prev);
    if (newSet.has(key)) {
      newSet.delete(key);
    } else {
      newSet.add(key);
    }
    return newSet;
  });
};

const [candidateQuestions, setCandidateQuestions] = useState([]);
const [message, setMessage] = useState("");

// BDD 10/17/2025
// === Draggable Sidebar Width ===
const [sidebarWidth, setSidebarWidth] = useState(
  Platform.OS === "web" && typeof window !== "undefined" ? Math.round(window.innerWidth * 0.25) : 360
);
const [isResizing, setIsResizing] = useState(false);
const startXRef = useRef(0);
const startWidthRef = useRef(360);

const MIN_SIDEBAR = 220;
const MAX_SIDEBAR = 720;

const beginResize = (e) => {
  const x = e?.nativeEvent?.clientX ?? e?.clientX ?? 0;
  setIsResizing(true);
  startXRef.current = x;
  startWidthRef.current = sidebarWidth;
};

const beginResizeTouch = (e) => {
  const touch = e?.nativeEvent?.touches?.[0];
  if (!touch) return;
  setIsResizing(true);
  startXRef.current = touch.clientX;
  startWidthRef.current = sidebarWidth;
};

const onMouseMove = React.useCallback((e) => {
  if (!isResizing) return;
  const dx = (e?.clientX ?? 0) - startXRef.current;
  const next = Math.max(MIN_SIDEBAR, Math.min(MAX_SIDEBAR, startWidthRef.current + dx));
  setSidebarWidth(next);
}, [isResizing]);

const onMouseUp = React.useCallback(() => {
  if (!isResizing) return;
  setIsResizing(false);
}, [isResizing]);

useEffect(() => {
  if (Platform.OS !== "web") return;
  if (isResizing) {
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  }
  return () => {
    if (Platform.OS !== "web") return;
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
  };
}, [isResizing, onMouseMove, onMouseUp]);

// BDD 10/23/2025 - TestPrep
// High‑level filters
const [gradeFilter, setGradeFilter] = useState(new Set()); // Set<number>
const [subjectFilter, setSubjectFilter] = useState(new Set()); // Set<number>
const [chapterFilter, setChapterFilter] = useState(new Set()); // Set<number>
const [collectionFilter, setCollectionFilter] = useState(new Set()); // Set<number>
// Collections
const [collectionsForBoard, setCollectionsForBoard] = useState([]); // [{id, name, ...}]
const [topicsByCollection, setTopicsByCollection] = useState({}); // { [collectionId]: [{chapter_id, topic_id, name}] }
// Auto‑compose controls
const [autoEasy, setAutoEasy] = useState(5);
const [autoMedium, setAutoMedium] = useState(5);
const [autoDifficult, setAutoDifficult] = useState(5);

const route = useRoute();
const boardKey = useMemo(() => {
  const b = route?.params?.board;
  return (b ? String(b).toLowerCase() : "anatomy");
}, [route?.params?.board]);
// const qKey = (id) => Number(id);
// BDD 12/28/2025 - AI Test Gen Related
// Always normalize question_id to a string (question-bank numeric IDs + AI UUIDs)
const qKey = (id) => String(id ?? "");
const [deletingTestId, setDeletingTestId] = useState(null);

// difficulty utils BDD 10/23/2025 - 5
const DIFF_BADGE = (d) => ({easy:"#10b981", medium:"#f59e0b", difficult:"#ef4444"}[(d||"").toLowerCase()] || "#6b7280");
const [compactView, setCompactView] = useState(false); // BDD 10/27/2025
const [showTeacherPreview, setShowTeacherPreview] = useState(false); // BDD 10/27/2025

function normalizeDiff(d) {
  const s = String(d||"").toLowerCase();
  if (s.includes("easy")) return "easy";
  if (s.includes("medium")) return "medium";
  if (s.includes("difficult") || s.includes("hard")) return "difficult";
  return "unknown";
}

function countByDifficulty(list) {
  const out = { easy:0, medium:0, difficult:0, unknown:0 };
  for (const q of list||[]) out[normalizeDiff(q.difficulty)]++;
  return out;
}

function countSelectedByDifficulty(list, selectedSet) {
  const out = { easy:0, medium:0, difficult:0, unknown:0 };
  for (const q of list||[]) {
    if (selectedSet.has(qKey(q.question_id))) out[normalizeDiff(q.difficulty)]++;
  }
  return out;
}
// BDD 12/15/2025
const [teacherClasses, setTeacherClasses] = useState([]);
const [selectedClassId, setSelectedClassId] = useState(null);
const [publishShareExpanded, setPublishShareExpanded] = useState(false); // BDD 12/17/2025 - lift state to prevent collapse on re-render
// BDD 12/15/2025
useEffect(() => {
  async function fetchClasses() {
    try {
      const classes = await getTeacherClasses(user_id); // teacher email
      setTeacherClasses(classes || []);
    } catch (err) {
      console.warn("Failed to fetch teacher classes", err);
    }
  }
  fetchClasses();
}, [user_id]);

function idsOfDifficulty(list, target) {
  const t = normalizeDiff(target);
  return new Set((list||[])
    .filter(q => normalizeDiff(q.difficulty) === t)
    .map(q => qKey(q.question_id)));
}

/** Toggle behavior:
 * - If not all of that difficulty are selected → select all of them
 * - If all are already selected → clear them
 */
function toggleSelectByDifficulty(visible, target, setSelectedQuestionIds) {
  const pool = idsOfDifficulty(visible, target);
  setSelectedQuestionIds(prev => {
    const curr = new Set(prev);
    let allSelected = true;
    for (const id of pool) if (!curr.has(id)) { allSelected = false; break; }

    // Toggle:
    if (allSelected) {
      for (const id of pool) curr.delete(id);
    } else {
      for (const id of pool) curr.add(id);
    }
    return curr;
  });
}

function countByDifficulty(list){
  const out = { easy:0, medium:0, difficult:0, unknown:0 };
  for (const q of list||[]) {
    const d = String(q?.difficulty||"").toLowerCase();
    if (d.includes("easy")) out.easy++;
    else if (d.includes("medium")) out.medium++;
    else if (d.includes("difficult") || d.includes("hard")) out.difficult++;
    else out.unknown++;
  }
  return out;
}

function filterByDifficulty(list, target){
  const t = String(target).toLowerCase();
  return (list||[]).filter(q=>{
    const d = String(q?.difficulty||"").toLowerCase();
    if (t==="easy") return d.includes("easy");
    if (t==="medium") return d.includes("medium");
    if (t==="difficult") return d.includes("difficult") || d.includes("hard");
    return false;
  });
}
// BDD 10/23/2025 - 5 - end

// BDD 10/23/2025 - TestPrep
/* ======================= 3) HELPERS (below state) ======================= */
// Normalize curriculum to convenient maps
const levels = useMemo(() => Array.isArray(curriculum) ? curriculum : [], [curriculum]);
const subjectsByLevel = useMemo(() => {
  const m = new Map();
  for (const lvl of levels) m.set(lvl.id, lvl.subjects || []);
  return m;
}, [levels]);
const chaptersBySubject = useMemo(() => {
  const m = new Map();
  for (const lvl of levels) for (const s of (lvl.subjects||[])) m.set(s.id, s.chapters || []);
  return m;
}, [levels]);
const topicsByChapter = useMemo(() => {
  const m = new Map();
  for (const lvl of levels) for (const s of (lvl.subjects||[])) for (const ch of (s.chapters||[])) m.set(ch.id, ch.topics || []);
  return m;
}, [levels]);

function toggleInSet(setter, id) {
  setter(prev => { const next = new Set(prev); next.has(id) ? next.delete(id) : next.add(id); return next; });
}

function addAllChapterTopics(chapterId) {
  const arr = topicsByChapter.get(chapterId) || [];
  setSelectedTopics(prev => {
    const next = new Set(prev);
    for (const t of arr) next.add(`${chapterId}-${t.id}`);
    return next;
  });
}
function removeAllChapterTopics(chapterId) {
  const arr = topicsByChapter.get(chapterId) || [];
  setSelectedTopics(prev => {
    const next = new Set(prev);
    for (const t of arr) next.delete(`${chapterId}-${t.id}`);
    return next;
  });
}


async function loadCollectionTopics(collectionId) {
  if (topicsByCollection[collectionId]) return; // cached
  try {
    // resolved = items with board_topic_id + source_topic_id; derive chapter/topic pairs if provided in your API
    const resolved = await apiGetCollectionResolved(collectionId);
    const rows = [];
    for (const it of (resolved?.items || [])) {
      if (it?.board_topic_id && it?.board_chapter_id) {
        rows.push({ chapter_id: Number(it.board_chapter_id), topic_id: Number(it.board_topic_id), name: it.module_title || `Topic ${it.board_topic_id}` });
      }
    }
    setTopicsByCollection(prev => ({ ...prev, [collectionId]: rows }));
  } catch(e) { console.warn("getCollectionResolved failed", e); }
}

function addAllCollectionTopics(collectionId) {
  const arr = topicsByCollection[collectionId] || [];
  setSelectedTopics(prev => {
    const next = new Set(prev);
    for (const t of arr) next.add(`${t.chapter_id}-${t.topic_id}`);
    return next;
  });
}
function removeAllCollectionTopics(collectionId) {
  const arr = topicsByCollection[collectionId] || [];
  setSelectedTopics(prev => {
    const next = new Set(prev);
    for (const t of arr) next.delete(`${t.chapter_id}-${t.topic_id}`);
    return next;
  });
}
/* ======================= 7) QUESTIONS LIST: selectable with Select‑All ======================= */
// function toggleQuestionPick(qid) {
//   setSelectedQuestionIds(prev => { const next = new Set(prev); const s = String(qid); next.has(s) ? next.delete(s) : next.add(s); return next; });
// }
// function pickAllVisibleQuestions(visible) {
//   setSelectedQuestionIds(prev => { const next = new Set(prev); for (const q of visible) next.add(String(q.question_id)); return next; });
// }

// BDD 12/28/2025 - AI Test Gen Related
function toggleQuestionPick(qid) {
  const k = qKey(qid);
  setSelectedQuestionIds(prev => {
    const next = new Set(prev);
    next.has(k) ? next.delete(k) : next.add(k);
    return next;
  });
}

// BDD 12/28/2025 - AI Test Gen Related
function pickAllVisibleQuestions(visible) {
  setSelectedQuestionIds(prev => {
    const next = new Set(prev);
    for (const q of visible) next.add(qKey(q.question_id));
    return next;
  });
}

function clearAllPicked() { setSelectedQuestionIds(new Set()); }

// Keep the topic list small by default
const didInitPreselect = useRef(false);
useEffect(() => {
  if (didInitPreselect.current) return;
  if (!levels.length) return;

  const firstWithSubjects = levels.find(l => Array.isArray(l.subjects) && l.subjects.length);
  const g = firstWithSubjects || levels[0];
  if (!g) return;

  setGradeFilter(new Set([g.id]));
  const firstSubject = (g.subjects || [])[0];
  if (firstSubject) setSubjectFilter(new Set([firstSubject.id]));

  didInitPreselect.current = true;
}, [levels]);

// In your question renderer, add a checkbox/toggle that calls toggleQuestionPick(question.question_id)

const ensureCollectionsLoaded = React.useCallback(async () => {
  if (collectionsForBoard.length) return;
  try {
    // Try object form first; if your helper expects a string, fall back
    let list;
    try {
      list = await apiListCollections({ board: boardKey });
    } catch {
      list = await apiListCollections(boardKey);
    }
    setCollectionsForBoard(Array.isArray(list) ? list : []);
    console.log("[Collections] loaded for board =", boardKey, "count=", list?.length ?? 0);
  } catch (e) {
    console.warn("list collections failed", e);
  }
}, [boardKey, collectionsForBoard.length]);

// useEffect(() => {
//   console.log("[TestQuestions] route.params =", route?.params);
//   console.log("[TestQuestions] boardKey =", boardKey);
// }, [route?.params, boardKey]);

function pairsFromCollection(resolved, collectionMeta) {
  const tree = buildCollectionTree(resolved, collectionMeta);
  const rows = [];
  const items = resolved?.items || [];

  const idxFromSynthetic = (syntheticId) => {
    const m = /-t-(\d+)$/.exec(String(syntheticId || ""));
    return m ? Number(m[1]) : null;
    // returns null if pattern not found
  };

  (tree || []).forEach(level => {
    (level.subjects || []).forEach(subject => {
      (subject.chapters || []).forEach(chapter => {
        (chapter.topics || []).forEach(topic => {
          const idx = idxFromSynthetic(topic.id);
          if (idx == null || !items[idx]) return;
          const it = items[idx];
          const chapter_id =
            Number(it.chapter_id ?? it.topic_snapshot?.chapter_id ?? chapter.id);
          const topic_id =
            Number(it.board_topic_id ?? it.topic_snapshot?.board_topic_id ?? topic.board_topic_id);

          if (Number.isFinite(chapter_id) && Number.isFinite(topic_id)) {
            rows.push({ chapter_id, topic_id, name: topic.name || `Topic ${topic_id}` });
          }
        });
      });
    });
  });

  // de-dup
  const seen = new Set();
  return rows.filter(r => {
    const k = `${r.chapter_id}-${r.topic_id}`;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
async function ensureCollectionTopics(collectionId) {
  if (topicsByCollection[collectionId]) return; // already loaded

  try {
    const resolved = await apiGetCollectionResolved(collectionId);
    const meta = collectionsForBoard.find(c => c.id === collectionId) || { id: collectionId, name: String(collectionId) };
    const pairs = pairsFromCollection(resolved, meta);
    setTopicsByCollection(prev => ({ ...prev, [collectionId]: pairs }));
  } catch (e) {
    console.warn("getCollectionResolved failed", e);
    setTopicsByCollection(prev => ({ ...prev, [collectionId]: [] }));
  }
}
async function confirmDeleteDialog(titleText) {
  if (Platform.OS === "web" && typeof window !== "undefined" && window.confirm) {
    return window.confirm(titleText);
  }
  return new Promise((resolve) => {
    Alert.alert(
      "Delete test?",
      titleText,
      [
        { text: "Cancel", style: "cancel", onPress: () => resolve(false) },
        { text: "Delete", style: "destructive", onPress: () => resolve(true) },
      ],
      { cancelable: true }
    );
  });
}

async function confirmUnpublishDialog(msg) {
  if (Platform.OS === "web" && typeof window !== "undefined" && window.confirm) {
    return window.confirm(msg);
  }
  return new Promise((resolve) => {
    Alert.alert(
      "Unpublish test?",
      msg,
      [
        { text: "Cancel", style: "cancel", onPress: () => resolve(false) },
        { text: "Unpublish", style: "destructive", onPress: () => resolve(true) },
      ],
      { cancelable: true }
    );
  });
}

// Tries a couple of common endpoints so it works with your existing card/API.
async function unpublishTest(id) {
  // Prefer a dedicated publish toggle if you have it:
  try {
    await axios.post(`${FASTAPI_BASE_URL}/api/tests/${id}/publish`, { is_published: false });
    return true;
  } catch (_) {}
  // Fallback to patching the test:
  try {
    await axios.patch(`${FASTAPI_BASE_URL}/api/tests/${id}`, { is_published: false });
    return true;
  } catch (_) {}
  // Last resort:
  try {
    await axios.put(`${FASTAPI_BASE_URL}/api/tests/${id}/publish`, { is_published: false });
    return true;
  } catch (e) {
    console.error("Failed to unpublish via known endpoints", e);
    return false;
  }
}


// BDD 10/23/2025 - TestPrep - End

// BDD CAUTION NOTE THIS FUNCTION IS COPY OF computeAnswerFeedback - should refactor code so that it can e 
const computeAnswerFeedbackTeacher = (quizData, studentAnswers) => {
    const feedback = {};
  
    quizData.forEach((question) => {
      // Get the correct answer from the question options.
      // It may be stored as "1", 1, or "option1".
      const correct = question.options?.correct_answer;
  
      // Normalize the correct answer into an index (number).
      let correctIndex;
      if (typeof correct === "number") {
        correctIndex = correct;
      } else if (typeof correct === "string") {
        if (correct.toLowerCase().startsWith("option")) {
          // Remove "option" prefix and parse the rest.
          correctIndex = parseInt(correct.slice(6), 10);
        } else {
          correctIndex = parseInt(correct, 10);
        }
      }
  
      // Get the student's answer for this question.
      // Assume it's stored as a string like "option1", "option2", etc.
      const studentAns = studentAnswers?.[question.question_id];
  
      // Convert the student's answer into an index.
      let studentIndex;
      if (typeof studentAns === "string" && studentAns.toLowerCase().startsWith("option")) {
        studentIndex = parseInt(studentAns.slice(6), 10);
      } else {
        // If not in "optionX" format, try parsing directly.
        studentIndex = parseInt(studentAns, 10);
      }
  
      // Compare: In the selection handler, the logic was selectedIndex + 1 === correctIndex.
      // Here, our studentIndex already represents the option number (e.g., 1 for "option1").
      // So we compare them directly.
      feedback[question.question_id] =
        studentIndex === correctIndex ? "correct" : "wrong";
    });
  
    return feedback;
  };

const handleSelectPastTestResultTeacher = async (result) => {
    try {
      setLoading(true);
      setMessage("");
  
      // Fetch detailed questions for the selected test using its test_id.
      const response = await axios.get(`${FASTAPI_BASE_URL}/tests/${result.test_id}/questions`);
      const parsedQuiz = response.data.quiz;
      setQuiz(parsedQuiz);
  
      // Set the student's answers from the result payload.
      setUserAnswers(result.answers);
  
      // Compute feedback for each question.
      const computedFeedback = computeAnswerFeedbackTeacher(parsedQuiz, result.answers);
      setAnswerFeedback(computedFeedback);
  
      // For teachers, you might want to use a different mode,
      // so that the view is read-only and can include any additional teacher-specific details.
    //   setQuizMode("pastTestViewTeacher");
  
      // Trigger rendering of the detailed view.
      setShowQuiz(true);
    } catch (error) {
      console.error("Error fetching test details for teacher view:", error);
      setMessage("Error fetching test details.");
    } finally {
      setLoading(false);
    }
  };
  

  // When teacher selects a test from the list, load its details
  // BDD 10/23/2025 modified for delete feature
  const handleSelectTest = async (test) => {
    // Clear previous errors and messages
    setValidationErrors({});
    setMessage("");

    setSelectedTest(test);
    setSelectedTestId(test.id); // Save the test ID for later use
    try {
      const res = await axios.get(`${FASTAPI_BASE_URL}/tests/${test.id}`);
      const td = res?.data?.test || {};
      setTestDetails({
        title: td.title || "",
        description: td.description || "",
        chapters: td.chapters || [],
        start_time: td.start_time || null,
        end_time: td.end_time || null,
        duration_minutes: td.duration_minutes ?? null,
        // ✅ force boolean; fall back to selectedTest if server omits it
        is_published: !!(td.is_published ?? test?.is_published ?? false),
      });
      // seed your picker state so the DateTimePickers open to the correct moment
      if (res.data.test.start_time) {
        setStartDate(new Date(res.data.test.start_time));
      }
      if (res.data.test.end_time) {
        setEndDate(new Date(res.data.test.end_time));
      }

        // console.log(", going to call test_id/questions: ",`${test.id}`)

        // Fetch test questions separately
        const response = await axios.get(`${FASTAPI_BASE_URL}/tests/${test.id}/questions`);
    
        // 🧠 Transform into AITutor-compatible format
        // console.log(", response from test id",`${test.id}`)
        // console.log(", response from test id",response.data)

        const parsedQuiz = response.data.quiz;

        console.log(
          "LEBANON 1 - RAW API QUESTION:",
          parsedQuiz?.[0]
        );

        const modifiedQuiz = parsedQuiz.map((q) => {
          let question_id;
          // BDD 08/24/2026 - LebanonQP
          if (q.external_question_id) {
            question_id = q.external_question_id;
          } else if (
            q.question_bank_id !== null &&
            typeof q.question_bank_id === "number" &&
            q.question_bank_id >= 0
          ) {
            question_id = q.question_bank_id;
          } else if (q.ai_question_uuid) {
            question_id = q.ai_question_uuid;
          } else {
            question_id = `temp-${Math.random().toString(36).substring(2, 8)}`;
          }

          return { ...q, question_id };
        });

        console.log(
          "LEBANON 2 - MODIFIED QUESTION:",
          modifiedQuiz?.[0]
        );
          // console.log("Parsed Quiz Data:fetchAdditionalQuestions", parsedQuiz);
        //   setQuiz(parsedQuiz); // Store parsed quiz data in React state
        //   console.log("parsedQuiz before rendering:", parsedQuiz);
        setExistingTestQuestions(modifiedQuiz); // Instead of overwriting quizData
        setQuiz(modifiedQuiz); // ← sets them into quiz for rendering
        // console.log("existingTestQuestions before rendering:", existingTestQuestions);
          // ✅ Pre-select questions already in the test
          // const preselected = new Set(
          //   modifiedQuiz.map((q) => q.question_id) // ✅ Use this instead of test.questions
          // );
          const preselected = new Set(
            modifiedQuiz.map((q) => {
              if (
                q.question_bank_id !== null &&
                typeof q.question_bank_id === "number" &&
                q.question_bank_id >= 0
              ) {
                return q.question_bank_id;
              } else if (q.ai_question_uuid) {
                return q.ai_question_uuid;
              } else {
                return q.question_id; // fallback
              }
            })
          );

          setSelectedQuestionIds(preselected);
          
    } catch (error) {
      // fallback so the UI still knows publish state
      setTestDetails(prev => ({
        ...prev,
        is_published: !!(test?.is_published ?? prev?.is_published ?? false),
      }));
      console.error("Error fetching test details:", error);
    }
  };
  const isExisting = existingTestQuestions.some(q => q.question_id === question.question_id);

  const validateTestDetails = () => {
    let errors = {};
    
    // Check required test details:
    if (!testDetails.title || testDetails.title.trim() === "") {
      errors.title = t("Test title is required.");
    }

    // Check that both start and end times are provided
    if (!testDetails.start_time || !testDetails.end_time) {
        errors.schedule = t("Both start and end times must be provided.");
    } else {
        // Convert to Date objects for comparison
        const start = new Date(testDetails.start_time);
        const end = new Date(testDetails.end_time);
        
        if (end <= start) {
        errors.schedule = t("End time must be greater than start time.");
        }
    }
    // Validate test duration is non-zero and positive
    if (!testDetails.duration_minutes || testDetails.duration_minutes <= 0) {
        errors.duration = t("Test duration must be greater than zero.");
     }  
       
 
    // BDD check if topics are selected, but only if there are no questions selected
    if (selectedQuestionIds.size === 0 && (!selectedTopics || selectedTopics.size === 0)) {
        errors.chapters = t("At least one topic must be selected. (For example, go to \"Topics for Test\", select one or more topics, and then click \"Fetch Questions\".)");
      }
  
    
    // Check if at least one question is selected:
    if (selectedQuestionIds.size === 0) {
        errors.questions = t("Please select at least one question for the test. (Ensure you click \"Fetch Questions\" and then choose questions for the test.)");
    }
    
      
    return errors;
  };

// BDD 10/23/2025
useEffect(() => {
  if (selectedTest?.id != null) {
    setTestDetails(prev => ({ ...prev, is_published: !!selectedTest.is_published }));
  }
}, [selectedTest?.id, selectedTest?.is_published]);
 
const handleSaveTest = async () => {
    // Clear previous errors before validating
    setValidationErrors({});
    setMessage("");
  
    const errors = validateTestDetails();
  
    // If the test is flagged as published but there are validation errors,
    // show the errors and prevent the save.
    if (testDetails.is_published && Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setMessage(t("Test cannot be published. Please complete all required fields."));
      return; // Prevent saving until errors are resolved.
    }
  
    // If any validation errors exist (even if not publishing), show them and stop.
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setMessage(t("Please complete all required fields before saving."));
      return; // Prevent saving.
    } else {
      setValidationErrors({});
    }
  
    try {
      const payload = {
        teacher_email: user_id, // Use authenticated email
        title: testDetails.title,
        description: testDetails.description,
        chapters: testDetails.chapters,
        start_time: new Date(testDetails.start_time).toISOString(),
        end_time: new Date(testDetails.end_time).toISOString(),
        duration_minutes: parseInt(testDetails.duration_minutes, 10) || 0,
        is_published: testDetails.is_published,
      };
  
      let res;
      // If a test is selected, we're updating an existing test.
      // Otherwise, we're creating a new test (for "Save As New").
      if (selectedTest) {
        res = await axios.patch(`${FASTAPI_BASE_URL}/tests/${selectedTest.id}`, payload);
        setMessage("Test updated successfully.");
        // Update the test in your tests list state, if necessary.
        setTests(prevTests =>
          prevTests.map(t => (t.id === selectedTest.id ? res.data : t))
        );
      } else {
        res = await axios.post(`${FASTAPI_BASE_URL}/tests`, payload);
        setSelectedTest(res.data);
        setMessage("Test created successfully.");
        // Append the new test to the tests list state.
        setTests(prevTests => [res.data, ...prevTests]);
      }
  
      // Collapse the test details UI.
    //   setShowTestDetails(false); // BDD this is irritating me, so not doing it
  
      // If we are updating an existing test (i.e. not "Save As New"), clear its current questions.
      // This prevents duplication by deleting all old test questions before adding new ones.
      if (selectedTest) {
        await axios.delete(`${FASTAPI_BASE_URL}/tests/${selectedTest.id}/questions`);
      }
  
      // Now add the selected questions to the test.
      await addSelectedQuestions();
    } catch (error) {
      console.error("Error saving test:", error);
      setMessage("Error saving test.");
    } finally {
      setLoading(false);
    }
  };

// BDD 10/23/2025
function autoPickByDifficulty(pool, counts) {
  const buckets = { easy: [], medium: [], difficult: [] };

  for (const q of pool) {
    const lvl = Number(q.difficulty_level ?? q.difficulty ?? 0);
    if (lvl === 1) buckets.easy.push(q);
    else if (lvl === 2) buckets.medium.push(q);
    else if (lvl === 3) buckets.difficult.push(q);
    else buckets.medium.push(q); // default bucket
  }

  const needEasy = Number(counts?.easy || 0);
  const needMed  = Number(counts?.medium || 0);
  const needDiff = Number(counts?.difficult || 0);
  const total    = needEasy + needMed + needDiff;

  // Sample without duplicates (stable order)
  const taken = new Set();
  const out   = [];

  function take(arr, n) {
    for (const q of arr) {
      const id = String(q.question_id ?? q.id ?? q.qid);
      if (taken.has(id)) continue;
      out.push(q);
      taken.add(id);
      if (out.length >= n) break;
    }
  }

  const targetAfterEasy   = needEasy;
  const targetAfterMedium = needEasy + needMed;

  // Easy
  take(buckets.easy, total); // we’ll stop later; this preserves original order
  // Reset to only easy count
  const trimmedEasy = out.splice(0, targetAfterEasy);

  // Medium
  take(buckets.medium, total);
  const trimmedMed = out.splice(0, needMed);

  // Difficult
  take(buckets.difficult, total);
  const trimmedDiff = out.splice(0, needDiff);

  let chosen = [...trimmedEasy, ...trimmedMed, ...trimmedDiff];

  // Top-up if any bucket ran short
  if (chosen.length < total) {
    const leftovers = pool.filter(q => !taken.has(String(q.question_id ?? q.id ?? q.qid)));
    chosen = chosen.concat(leftovers.slice(0, total - chosen.length));
  }

  const chosenIds = new Set(chosen.map(q => String(q.question_id ?? q.id ?? q.qid)));
  return { chosen, chosenIds };
}

// BDD 10/23/2025 new fetchAdditionalQuestions for auto fetch based on difficulty level
const fetchAdditionalQuestions = async (opts = {}) => { 
    const { auto = false, counts = { easy: 0, medium: 0, difficult: 0 }, mode = "preselect" } = opts;

    if (selectedTopics.size === 0) {
      Alert.alert(t("Please select at least one topic."));
      return;
    }
  
    const selectedPairs = Array.from(selectedTopics).map((key) => {
      const [chapterId, topicId] = key.split("-");
      return { chapter_id: parseInt(chapterId), topic_id: parseInt(topicId) };
    });
  
    console.log("Fetching questions for:", selectedPairs);
    console.log("LanguageIDquiz:", languageIDquiz)
    setLoading(true);
    setMessage("");
  
    try {
      const response = await axios.post(`${FASTAPI_BASE_URL}/question-bank/fetch_New2`, {
        pairs: selectedPairs,
        language_id: languageIDquiz,
      });
  
        const raw = Array.isArray(response?.data?.quiz) ? response.data.quiz : [];
        // Normalize to your UI shape (you already do this)
        const parsedQuiz = raw.map((question) => ({
          ...question,
          options: {
            correct_answer: question.options?.correct_answer,
            option1: question.options?.option1,
            option2: question.options?.option2,
            option3: question.options?.option3,
            option4: question.options?.option4,
          },
          hints: {
            hint1: question.hints?.hint1,
            hint2: question.hints?.hint2,
          },
          solution: question.solution,
          // keep difficulty fields from backend if present
          difficulty_level: question.difficulty_level,
          difficulty: question.difficulty,
        }));

        // Dedupe with existing pool → compute the *next* list locally
        const next = (() => {
          const merged = [...quiz, ...parsedQuiz];
          const dedupedMap = new Map();
          merged.forEach((q) => {
            dedupedMap.set(String(q.question_id), q);
          });
          return Array.from(dedupedMap.values());
        })();

        if (!auto) {
          // Normal path: keep full pool visible
          setQuiz(next);
          return;
        }
        console.log("next:", next);
        // Auto path: pick subset by difficulty over the freshly-fetched pool
        const { chosen, chosenIds } = autoPickByDifficulty(next, counts);
        console.log("chosenIds:", chosenIds);
        console.log("chosen:", chosen);

        if (mode === "replace") {
          // Show only the chosen questions
          setQuiz(chosen);
          setSelectedQuestionIds(new Set(chosen.map(q => qKey(q.question_id))));
        } else {
          // Default: keep full pool visible but preselect the chosen ones
          setQuiz(next);
          // setSelectedQuestionIds(chosenIds);
          // chosenIds might be a Set of strings (depending on your picker) → normalize:
          setSelectedQuestionIds(new Set(Array.from(chosenIds).map(qKey)));
        }

    } catch (error) {
      console.error("Error fetching candidate questions:", error);
      setMessage("Error fetching questions.");
    } finally {
      setLoading(false);
    }
  };
  
// Example: Add selected questions to a test using the add_test_question API
const addSelectedQuestions = async () => {
    if (!selectedTest) {
        setMessage(t("Please select or create a test first."));
        return;
      }
    const testId = selectedTest.id; // Now you have the test id
    setLoading(true);
    setMessage("");
  
    try {
      // Assume 'quizData' is the state variable that holds all candidate questions
      // and 'selectedQuestionIds' is a Set containing the IDs of the selected questions.
      const selectedQuestions = quiz.filter((question) =>
        selectedQuestionIds.has(qKey(question.question_id))
      );
  
      // Loop over each selected question and build the payload.
      for (const question of selectedQuestions) {
        // console.log("Questions:", question)
        // Determine whether the question was edited.
        // For example, you might add an 'isEdited' flag when a teacher makes changes.
        // const questionBankId = question.isEdited ? null : question.question_bank_id; // Edited function is not implemented yet
        // const questionBankId = question.question_bank_id;
        // BDD 08/24/2026 - LebanonQP

        let question_bank_id = -2;
        let ai_question_uuid = null;
        let external_question_id = question.external_question_id || null;
        let question_source = "manual";

        if (external_question_id) {
          question_bank_id = null;
          ai_question_uuid = null;
          question_source = question.question_source || "lebanon_official_exam";
        } else if (!isNaN(Number(question.question_id))) {
          question_bank_id = Number(question.question_id);
          question_source = "manual";
        } else {
          ai_question_uuid = question.ai_question_uuid || question.question_id;
          question_source = question.question_source || "ai";
        }

        console.log(
          "Lebanon save check:",
          question.question_id,
          question.external_question_id,
          question.official_points,
          question.question_source
        );

        // BDD 08/24/2026 - LebanonQP
        const payload = {
          question_bank_id,
          ai_question_uuid,
          external_question_id, // BDD 08/24/2026 - LebanonQP

          question_text:
            typeof question.question === "string"
              ? question.question
              : JSON.stringify(question.question),

          question_type:
            question.question_type != null
              ? question.question_type.toString()
              : "",

          options:
            question.options
              ? JSON.stringify(question.options)
              : null,

          correct_answer:
            question.correct_answer != null
              ? String(question.correct_answer)
              : question.options?.correct_ans != null
                ? String(question.options.correct_ans)
                : null,

          score: question.score ?? 1,

          official_points:
            question.official_points ?? null, // BDD 08/24/2026 - LebanonQP

          difficulty_level: question.difficulty_level, // BDD 10/27/2025
          difficulty: question.difficulty,             // BDD 10/27/2025

          order: question.order ?? 0,

          hints:
            question.hints
              ? JSON.stringify(question.hints)
              : null,

          solution:
            question.solution
              ? JSON.stringify(question.solution)
              : null,

          question_source,

          language_id: question.language_id ?? 1,
        };
  
        // console.log("🚨 SUBMITTING QUESTION TYPE:", question.question_type);
        // console.log("🚀 Full Payload:", JSON.stringify(payload, null, 2));

        // Send the payload to the API endpoint.
        await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/questions`, payload, {
          headers: { "Content-Type": "application/json" },
        });
      }

      if (question.order === 1) {
        console.log(
          "LEBANON 3 - QUESTION BEFORE POST:",
          question
        );

        console.log(
          "LEBANON 4 - PAYLOAD TO POST:",
          payload
        );
      }

      setMessage("Selected questions added successfully!");
    } catch (error) {
      console.error("Error adding selected questions:", error);
      setMessage("Error adding selected questions.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/manage`);
        const data = await res.json();

        // Combine published + unpublished tests into a single array
        const allTests = [...data.published, ...data.unpublished];

        // Optional: Sort by ID descending or by start_time if you want
        allTests.sort((a, b) => b.id - a.id);

        setTests(allTests);
      } catch (err) {
        console.error("Error fetching tests:", err);
      }
    };
    fetchTests();
  }, [fetchWithAuth]);
  

      
  useEffect(() => {
    const fetchCurriculum = async () => {
        try {
            const response = await axios.get(API_URL_CURRICULUM);
            setCurriculum(response.data);

        } catch (error) {
            console.error("Error fetching curriculum:", error);
        }
    };
    fetchCurriculum();
    }, []);

    useEffect(() => {
        if (curriculum.length > 0) {
            const initialExpanded = {};
            curriculum.forEach((grade) => {
                initialExpanded[grade.id] = {};
                grade.subjects.forEach((subject) => {
                    initialExpanded[grade.id][subject.id] = true;  // ✅ Start expanded
                });
            });
            setExpandedSubjects(initialExpanded);
        }
    }, [curriculum]); // ✅ Triggers when curriculum is set

    const toggleExpandSubject = (gradeId, subjectId) => {
        setExpandedSubjects((prev) => ({
            ...prev,
            [gradeId]: { ...prev[gradeId], [subjectId]: !prev[gradeId]?.[subjectId] },
        }));
    };

    const toggleExpandChapter = (subjectId, chapterId) => {
        setExpandedChapters((prev) => ({
            ...prev,
            [subjectId]: { ...prev[subjectId], [chapterId]: !prev[subjectId]?.[chapterId] },
        }));
    };

    const toggleExpandTopic = async (chapterId, topicId) => {
        if (!expandedTopics[chapterId]?.[topicId]?.videos) {
            try {
                const response = await axios.get(`${FASTAPI_BASE_URL}/content/${topicId}`, {
                    params: { language_id: languageID }
                });
                const topicContent = response.data;
                // console.log("topicContent:", topicContent);

                setExpandedTopics((prev) => ({
                    ...prev,
                    [chapterId]: {
                        ...prev[chapterId],
                        [topicId]: { expanded: true, ...topicContent }
                    }
                }));

                // Γ£à Set Videos & PWO initially collapsed when topic expands
                setExpandedVideos((prev) => ({
                    ...prev,
                    [`${chapterId}-${topicId}`]: false
                }));
                setExpandedPWOs((prev) => ({
                    ...prev,
                    [`${chapterId}-${topicId}`]: false
                }));

            } catch (error) {
                console.error(`Error fetching content for topic ${topicId}:`, error);
            }
        } else {
            setExpandedTopics((prev) => ({
                ...prev,
                [chapterId]: {
                    ...prev[chapterId],
                    [topicId]: {
                        ...prev[chapterId][topicId],
                        expanded: !prev[chapterId][topicId].expanded
                    }
                }
            }));
        }
    };
    const toggleExpandVideos = (chapterId, topicId) => {
        setExpandedVideos((prev) => ({
            ...prev,
            [`${chapterId}-${topicId}`]: !prev[`${chapterId}-${topicId}`]
        }));
    };

    const toggleExpandPWOs = (chapterId, topicId) => {
        setExpandedPWOs((prev) => ({
            ...prev,
            [`${chapterId}-${topicId}`]: !prev[`${chapterId}-${topicId}`]
        }));
    };
    const handleTeacherDashboard = () => {
        handleCloseModule();  // Reset any open module before switching
        setActiveModule("teacherDashboard");
        setShowQuiz(false);  // Hide quiz
        setShowQuiz(false);
        setActiveTopic(null); /* Reset if not PWO or video */
        setActiveVideo(null);
        setActivePWO(null);  // Reset PWO when playing video
    };
    

    const submitQuiz = async () => {
        if (!assessmentId) {
            console.error("Γ¥î Error: No assessment ID found, cannot submit quiz.");
            return;
        }

        const totalQuestions = Object.keys(quizResponses).length;
        const correctAnswers = Object.values(quizResponses).filter(ans => ans === "correct").length;
        const wrongAnswers = Object.values(quizResponses).filter(ans => ans === "wrong").length;
        const unattempted = totalQuestions - attemptedQuestions.length;
        const score = correctAnswers; // Γ£à Assuming 1 point per correct answer
        const totalScore = totalQuestions; // Γ£à Total possible score

        const quizData = {
            assessment_id: Number(assessmentId),
            student_id: String(user_id),
            correct_answers: Number(correctAnswers),
            total_questions: Number(totalQuestions),
            unattempted: Number(unattempted),
            score: Number(score),  // Γ£à Added score
            total_score: Number(totalScore)  // Γ£à Added total_score
        };

        // console.log("≡ƒôñ Sending Quiz Data:", quizData);

        try {
            const response = await axios.post(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/submit-quiz`, quizData, {
                headers: { "Content-Type": "application/json" }
            });
            // alert("Quiz submitted successfully!");
        } catch (error) {
            console.error("Error submitting quiz:", error.response ? error.response.data : error);
        }
    };

const handleCloseModule = async () => {
  // console.log("Γ¥î Closing any active module:");
  if (showQuiz) {
    await submitQuiz();
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }
  setActiveModule(null);
  setShowVideo(false);
  setUploadedFile(null);
  setCurrentVideoId(null);
  setCurrentVideoTagID(null);
  setCurrentPwoId(null);
  setCurrentPwoScene(null);
  setShowQuiz(false);
  setShowPwo(false);
  if (typeof fallbackTimeoutId !== "undefined" && fallbackTimeoutId !== null) {
    clearTimeout(fallbackTimeoutId);
  }
  // Remove the WEBGL_READY listener if it still exists.
  if (webglReadyHandlerRef.current) {
    window.removeEventListener("message", webglReadyHandlerRef.current);
    webglReadyHandlerRef.current = null;
  }
  // Remove the UNAUTHORIZED listener if it exists.
  if (unauthorizedHandlerRef.current) {
    window.removeEventListener("message", unauthorizedHandlerRef.current);
    unauthorizedHandlerRef.current = null;
  }
};
  
  

// Function to handle text-based answers (Fill in the Blank, Long Answer)
const handleAnswerChange = (questionId, answer) => {
    setUserAnswers((prev) => ({
        ...prev,
        [questionId]: answer
    }));
};

const checkTextAnswer = async (questionId, correctAnswer) => {
    if (!userAnswers[questionId]) {
        setQuizResponses(prev => ({
            ...prev,
            [questionId]: "unattempted"
        }));
        return;
    }

    try {
        const response = await axios.post("${FASTAPI_BASE_URL}/check-answer", {
            question_id: questionId,
            user_answer: userAnswers[questionId]
        });

        const isCorrect = response.data.is_correct;

        setUserAnswers(prev => ({
            ...prev,
            [questionId]: isCorrect ? "Γ£à Correct!" : "Γ¥î Incorrect"
        }));

        setQuizResponses(prev => ({
            ...prev,
            [questionId]: isCorrect ? "correct" : "wrong"
        }));

        // Γ£à Only add to attempted if it's the first time answering this question
        setAttemptedQuestions(prev => (prev.includes(questionId) ? prev : [...prev, questionId]));
    } catch (error) {
        console.error("Error checking answer:", error);
    }
};
const handleAutoSelectQuestions = (count) => {
  if (!quiz || quiz.length === 0) {
    Alert.alert("No questions loaded. Please fetch questions first.");
    return;
  }

  const mcqOnly = quiz.filter((q) => parseInt(q.question_type) === 2);
  if (mcqOnly.length === 0) {
    Alert.alert("No MCQ-type questions available.");
    return;
  }

  const shuffled = [...mcqOnly].sort(() => 0.5 - Math.random());
  const selected = shuffled.slice(0, count);

  const newSelectedIds = new Set(selected.map((q) => q.question_id));

  setSelectedQuestionIds((prev) => {
    const updated = new Set(prev);
    newSelectedIds.forEach((id) => updated.add(id));
    return updated;
  });
};

const handleMCQSelection = (questionId, selectedOption, selectedIndex, correctAnswerIndex) => {
    const correctIndex = parseInt(correctAnswerIndex, 10);

    if (isNaN(correctIndex)) {
        console.error(`Γ¥î Error: correctAnswerIndex is NaN for Question ID: ${questionId}`);
        return;
    }

    const isCorrect = selectedIndex + 1 === correctIndex;

    // Track the question's response (correct/wrong)
    setQuizResponses(prev => ({
        ...prev,
        [questionId]: isCorrect ? "correct" : "wrong"
    }));

    setUserAnswers(prev => ({
        ...prev,
        [questionId]: selectedOption
    }));

    setAnswerFeedback(prev => ({
        ...prev,
        [questionId]: isCorrect ? "correct" : "wrong"
    }));

    // Γ£à Increment attempted count only if this is the first attempt for the question
    setAttemptedQuestions(prev => (prev.includes(questionId) ? prev : [...prev, questionId]));
};

const handleGenerateAITest = async () => {
  try {
    const selectedPairs = Array.from(selectedTopics).map((key) => {
      const [chapterId, topicId] = key.split("-");
      return {
        chapter_id: parseInt(chapterId),
        topic_id: parseInt(topicId),
      };
    });

    // BDD 12/15/2025
    const gradeNum = parseInt(aiGrade, 10) || 7;
    const mcqNum = parseInt(aiCountMCQ, 10) || 0;
    const fillNum = parseInt(aiCountFill, 10) || 0;
    const assocNum = parseInt(aiCountAssoc, 10) || 0;
    const shortEssayNum = parseInt(aiCountShortEssay, 10) || 0;
    const longEssayNum = parseInt(aiCountLongEssay, 10) || 0;

    const payload = {
      subject_id: 1, // selectedSubject // BDD TEMP
      subject_name: "Science", // ✅ new (backend optional)
      language_id: languageIDquiz || 1,               // ✅ respect selected language
      chapter_topic_pairs: selectedPairs,
      grade_level: gradeNum, // selectedGrade, //  BDD TEMP
      difficulty: aiDifficulty,
      num_mcq: mcqNum,
      num_fill_in_the_blank: fillNum,
      num_word_assoc: assocNum,
      num_short_essay: shortEssayNum,
      num_long_essay: longEssayNum,
      instructions: aiInstructions, // ✅ pass this along
    };
    console.log("🧠 Payload in handleGenerateTest:", payload);

    const response = await axios.post(`${FASTAPI_BASE_URL}/teacher/generate-ai-test`, payload);

    console.log("🧠 response in handleGenerateTest:", response);

    const aiQuestions = response.data.questions || [];
    console.log("🧠 aiQuestions in handleGenerateTest:", aiQuestions);

    setQuiz((prev) => {
      const merged = [...prev, ...aiQuestions];
      const dedupedMap = new Map();
      merged.forEach((question) => {
        dedupedMap.set(String(question.question_id), question);
      });
      const dedupedList = Array.from(dedupedMap.values());
      console.log("🧠 Total Quiz Questions after AI Merge:", dedupedList);

      return dedupedList;
    });
  } catch (error) {
    console.error("❌ AI Test Generation Error:", error);
    alert("❌ Failed to generate questions. Check console for details.");
  }
};

// Function to toggle hints visibility
const toggleHint = (questionId) => {
    setShowHints((prev) => ({
        ...prev,
        [questionId]: !prev[questionId]
    }));
};

// Function to toggle solutions visibility
const toggleSolution = (questionId) => {
    setShowSolutions((prev) => ({
        ...prev,
        [questionId]: !prev[questionId]
    }));
};

const toggleQuestionSelection = (questionId) => {
    const k = qKey(questionId); // BDD 10/23/2025
    setSelectedQuestionIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(questionId)) {
        newSet.delete(questionId);
      } else {
        newSet.add(questionId);
      }
      return newSet;
    });
  };
  
// BDD 3/5/2025 - Fresh Try3 - to handle multi line equations as well

const MarkdownRenderer = ({ content }) => {
    // console.log("≡ƒöì Raw Markdown Content:", content);

    // Γ£à Pre-process Math Equations & Fix JSX Interpretation Issues
    const preProcessedContent = content
        .replace(/\$\$(.*?)\$\$/gs, (_, equation) => {
            equation = equation.trim().replace(/\s+/g, ' '); // Γ£à Remove extra spaces
            equation = equation.replace(/\\left/g, "").replace(/\\right/g, ""); // Γ£à Fix `{}` JSX parsing issue
            equation = equation.replace(/\\/g, "\\\\"); // Γ£à Escape backslashes properly
            equation = equation.replace(/_/g, "\\_"); // Γ£à Escape underscores to prevent JSX misinterpretation
            equation = equation.replace(/}/g, "\\}").replace(/{/g, "\\{"); // Γ£à Escape `{}` braces
            return `<BlockMath>${equation}</BlockMath>`; // Γ£à Ensure block math renders correctly
        })
        .replace(/\$(.*?)\$/g, (_, equation) => {
            equation = equation.trim().replace(/\s+/g, ' '); // Γ£à Remove extra spaces
            equation = equation.replace(/\\left/g, "").replace(/\\right/g, ""); // Γ£à Fix `{}` JSX parsing issue
            equation = equation.replace(/\\/g, "\\\\"); // Γ£à Escape backslashes properly
            equation = equation.replace(/_/g, "\\_"); // Γ£à Escape underscores
            equation = equation.replace(/}/g, "\\}").replace(/{/g, "\\{"); // Γ£à Escape `{}` braces
            return `<InlineMath>${equation}</InlineMath>`; // Γ£à Ensure inline math renders correctly
        });

    // console.log("≡ƒöì Processed Content for Markdown:", preProcessedContent);

    return (
        <View>
            <Markdown
                options={{
                    overrides: {
                        BlockMath: {
                            component: ({ children }) => {
                                // Γ£à Convert 'children' into a STRING for proper rendering
                                let equation = Array.isArray(children) ? children.join("") : children;
                                equation = String(equation);
                                // console.log("≡ƒƒó BlockMath Equation:", equation);
                                return <BlockMath>{equation}</BlockMath>;
                            },
                        },
                        InlineMath: {
                            component: ({ children }) => {
                                let equation = Array.isArray(children) ? children.join("") : children;
                                equation = String(equation);
                                // console.log("≡ƒƒó InlineMath Equation:", equation);
                                return <InlineMath>{equation}</InlineMath>;
                            },
                        },
                    },
                }}
            >
                {preProcessedContent}
            </Markdown>
        </View>
    );
};

useEffect(() => {
    if (loading) {
        const interval = setInterval(() => {
            setLoadingDots((prev) => (prev + 1) % 4); // Cycles between 0,1,2,3 for dots
        }, 500); // Update every 500ms for smooth animation
        return () => clearInterval(interval);
    } else {
        setLoadingDots(0); // Reset when not loading
    }
}, [loading]);
const renderWordAssociationBlock = (question, index) => {
  const pairs = question.options?.pairs || [];
  return (
    <View style={{ marginTop: 10 }}>
      {pairs.map((pair, idx) => (
        <View
          key={idx}
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
            padding: 10,
            backgroundColor: "#f0f0f0",
            borderRadius: 8,
          }}
        >
          {/* Left item */}
          <View style={{ flex: 1 }}>
            {pair.left?.text && (
              <Text style={{ fontWeight: "600", fontSize: 14 }}>{pair.left.text}</Text>
            )}
            {pair.left?.images?.map((img, i) => (
              <Image
                key={`left-${i}`}
                source={{ uri: img.base64 }}
                style={{
                  width: img.width < 150 ? img.width : img.orientation === "horizontal" ? "100%" : "50%",
                  height: img.height < 150 ? img.height : img.orientation === "vertical" ? 300 : 250,
                  resizeMode: "contain",
                  marginTop: 4,
                }}
              />
            ))}
          </View>

          <Text style={{ marginHorizontal: 10 }}>→</Text>

          {/* Right item */}
          <View style={{ flex: 1 }}>
            {pair.right?.text && (
              <Text style={{ fontWeight: "600", fontSize: 14 }}>{pair.right.text}</Text>
            )}
            {pair.right?.images?.map((img, i) => (
              <Image
                key={`right-${i}`}
                source={{ uri: img.base64 }}
                style={{
                  width: img.width < 150 ? img.width : img.orientation === "horizontal" ? "100%" : "50%",
                  height: img.height < 150 ? img.height : img.orientation === "vertical" ? 300 : 250,
                  resizeMode: "contain",
                  marginTop: 4,
                }}
              />
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};

// const renderQuestionBlock = (question, index) => {
//     const questionId = qKey(question.question_id); // BDD 10/23/2025
//     const qType = parseInt(question.question_type);

//     return (
//         <TouchableOpacity
//             key={index}
//             onPress={() => toggleQuestionSelection(questionId)}
//             style={[
//                 styles(isDarkMode).quizCardContainer,
//                 selectedQuestionIds.has(qKey(questionId)) && { borderColor: "#AB274F", borderWidth: 2 }
//             ]}
//         >

//             {/* header row BDD 10/23/2025 - 5 */}
//             {/* top of the card content BDD 10/27/2025 */}
//             <View style={{ flexDirection:"row", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
//               <Text style={{ fontWeight:"600" }}>Q{index+1}</Text>
//               {!!question?.difficulty && (
//                 <View style={{ paddingVertical:2, paddingHorizontal:6, borderRadius:999, backgroundColor: DIFF_BADGE(question.difficulty) }}>
//                   <Text style={{ fontSize:10, color:"#fff", textTransform:"capitalize" }}>{question.difficulty}</Text>
//                 </View>
//               )}
//             </View>

//             {/* Question Text */}
//             <Text style={styles(isDarkMode).quizQuestion}>
//                 {question.question?.text || t("No question available")}
//             </Text>

//             {/* Question Images */}
//             {question.question?.images?.length > 0 &&
//                 question.question.images.map((image, imgIndex) => (
//                     <Image
//                         key={imgIndex}
//                         source={{ uri: image.base64 }}
//                         style={{
//                             width: image.width < 150 ? image.width : image.orientation === "horizontal" ? "100%" : "50%",
//                             height: image.height < 150 ? image.height : image.orientation === "vertical" ? 300 : 250,
//                             resizeMode: "contain",
//                             marginVertical: 5
//                         }}
//                     />
//                 ))}

//             {/* Question Types */}
//             {qType === 1 ? (
//               <>
//                 {question.word_bank?.length > 0 && (
//                   <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginBottom: 10 }}>
//                     <Text style={{ fontWeight: 'bold', marginRight: 5 }}>🧩 Word Bank:</Text>
//                     {question.word_bank.map((word, idx) => (
//                       <Text
//                         key={idx}
//                         style={{
//                           backgroundColor: "#eee",
//                           paddingHorizontal: 8,
//                           paddingVertical: 4,
//                           borderRadius: 4,
//                           marginRight: 8,
//                           marginBottom: 6
//                         }}
//                       >
//                         {word}
//                       </Text>
//                     ))}
//                   </View>
//                 )}

//                 <TextInput
//                   style={styles(isDarkMode).inputField}
//                   placeholder={t("Type your answer...")}
//                   value={userAnswers?.[questionId] || ""}
//                   onChangeText={(text) => handleAnswerChange(questionId, text)}
//                   onBlur={() => checkTextAnswer(questionId, question.options?.correct_answer)}
//                 />
//               </>
//             ) : qType === 2 ? (
//                 <View>
//                     {["option1", "option2", "option3", "option4"].map((optKey, idx) => {
//                         const option = question.options?.[optKey];
//                         if (!option) return null;

//                         const isSelected = userAnswers?.[questionId] === optKey;
//                         const isCorrect = answerFeedback?.[questionId] === "correct";

//                         return (
//                             <TouchableOpacity
//                                 key={idx}
//                                 style={[
//                                     styles(isDarkMode).quizOption,
//                                     isSelected && (isCorrect ? styles(isDarkMode).correctAnswer : styles(isDarkMode).wrongAnswer)
//                                 ]}
//                                 onPress={() =>
//                                     handleMCQSelection(questionId, optKey, idx, `${question.options?.correct_answer}`)
//                                 }
//                             >
//                                 <Text style={styles(isDarkMode).optionText}>
//                                     Option {idx + 1}: {option.text}
//                                 </Text>
//                                 {option.images?.length > 0 &&
//                                     option.images.map((img, imgIdx) => (
//                                         <Image
//                                             key={imgIdx}
//                                             source={{ uri: img.base64 }}
//                                             style={{
//                                                 width: img.width < 150 ? img.width : img.orientation === "horizontal" ? "100%" : "50%",
//                                                 height: img.height < 150 ? img.height : img.orientation === "vertical" ? 300 : 250,
//                                                 resizeMode: "contain",
//                                                 marginVertical: 5
//                                             }}
//                                         />
//                                     ))}
//                             </TouchableOpacity>
//                         );
//                     })}
//                 </View>
//             ) : qType === 4 ? (
//                 <View>
//                     {["True", "False"].map((option, idx) => (
//                         <TouchableOpacity
//                             key={idx}
//                             style={[
//                                 styles(isDarkMode).quizOption,
//                                 userAnswers?.[questionId] === option &&
//                                 (option === question.options?.correct_answer
//                                     ? styles(isDarkMode).correctAnswer
//                                     : styles(isDarkMode).wrongAnswer)
//                             ]}
//                             onPress={() =>
//                                 handleMCQSelection(questionId, option, question.options?.correct_answer)
//                             }
//                         >
//                             <Text>{t("option")}</Text>
//                         </TouchableOpacity>
//                     ))}
//                 </View>
//             ) : qType === 9 ? (
//               renderWordAssociationBlock(question, index)
//             ) : null}
//             {/* Hint */}
//             {(question.hints?.hint1?.text || question.hints?.hint2?.text || question.hints?.hint1?.images?.length || question.hints?.hint2?.images?.length) && (
//                 <TouchableOpacity onPress={() => toggleHint(questionId)} style={styles(isDarkMode).hintButton}>
//                     <Text style={styles(isDarkMode).hintText}>
//                         <MaterialCommunityIcons name="lightbulb-outline" size={18} color="#FFF" /> {t("Show Hint")}
//                     </Text>
//                 </TouchableOpacity>
//             )}

//             {showHints?.[questionId] && (
//                 <View>
//                     <Text style={styles(isDarkMode).hintText}>
//                         {question.hints?.hint1?.text || ""} {question.hints?.hint2?.text || ""}
//                     </Text>
//                     {[...(question.hints?.hint1?.images || []), ...(question.hints?.hint2?.images || [])].map((image, imgIndex) => (
//                         <Image
//                             key={imgIndex}
//                             source={{ uri: image.base64 }}
//                             style={{
//                                 width: image.width < 150 ? image.width : image.orientation === "horizontal" ? "100%" : "50%",
//                                 height: image.height < 150 ? image.height : image.orientation === "vertical" ? 300 : 250,
//                                 resizeMode: "contain",
//                                 marginVertical: 5
//                             }}
//                         />
//                     ))}
//                 </View>
//             )}

//             {/* Solution Button */}
//             <TouchableOpacity onPress={() => toggleSolution(questionId)} style={styles(isDarkMode).solutionButton}>
//                 <Text style={styles(isDarkMode).solutionButtonText}>
//                     <MaterialCommunityIcons name="lightbulb-on-outline" size={18} color="#FFF" /> {t("Show Solution")}
//                 </Text>
//             </TouchableOpacity>

//             {/* Solution Text */}
//             {showSolutions?.[questionId] && (
//                 <View>
//                     <Text style={styles(isDarkMode).solutionText}>{question.solution?.text || t("No solution available")}</Text>
//                     {question.solution?.images?.length > 0 &&
//                         question.solution.images.map((image, imgIndex) => (
//                             <Image
//                                 key={imgIndex}
//                                 source={{ uri: image.base64 }}
//                                 style={{
//                                     width: image.width < 150 ? image.width : image.orientation === "horizontal" ? "100%" : "50%",
//                                     height: image.height < 150 ? image.height : image.orientation === "vertical" ? 300 : 250,
//                                     resizeMode: "contain",
//                                     marginTop: 5
//                                 }}
//                             />
//                         ))}
//                 </View>
//             )}
//         </TouchableOpacity>
//     );
// };
// BDD 10/27/2025 - allowing collapsing of question display while creating test
const renderQuestionBlock = (question, index, compactView) => {
  const questionId = qKey(question.question_id);
  const qType = parseInt(question.question_type);

  const isPicked = selectedQuestionIds.has(qKey(questionId));
  const difficultyLabel =
    question?.difficulty ||
    ({ 1: "easy", 2: "medium", 3: "difficult" }[question?.difficulty_level] || "");

  // We’ll take first line of the question text for compact view.
  const fullText = question.question?.text || t("No question available");
  const firstLine = fullText.split("\n")[0];

  // Same badge color logic you already had
  const badgeColor = DIFF_BADGE
    ? DIFF_BADGE(difficultyLabel)
    : "#6b7280"; // fallback grey if DIFF_BADGE is undefined

  if (compactView) {
    // ─────────────────────────────────────────
    // COMPACT CARD
    // ─────────────────────────────────────────
    return (
      <TouchableOpacity
        key={index}
        onPress={() => toggleQuestionSelection(questionId)}
        style={[
          {
            borderWidth: 3,
            borderColor: isPicked ? "#AB274F" : (isDarkMode ? "rgba(148,163,184,0.15)" : "#d1d5db"),
            backgroundColor: isDarkMode ? "#1e293b" : "#fff",
            borderRadius: 10,
            padding: 8,
            marginBottom: 8,
          },
        ]}
      >
        {/* Row: Q#, difficulty pill */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 4,
            justifyContent: "space-between",
          }}
        >
          <Text style={{ fontWeight: "600", fontSize: 13 }}>Q{index + 1}</Text>

          {!!difficultyLabel && (
            <View
              style={{
                paddingVertical: 2,
                paddingHorizontal: 6,
                borderRadius: 999,
                backgroundColor: badgeColor,
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                {difficultyLabel}
              </Text>
            </View>
          )}
        </View>

        {/* Preview line of question */}
        <Text
          numberOfLines={2}
          style={{
            fontSize: 13,
            color: "#111827",
          }}
        >
          {firstLine}
        </Text>

        {/* meta row: type label */}
        <Text
          style={{
            marginTop: 4,
            fontSize: 11,
            color: "#6b7280",
          }}
        >
          {qType === 2
            ? "MCQ"
            : qType === 1
            ? "Fill-in / Short answer"
            : qType === 3
            ? "True/False"
            : qType === 4
            ? "Multi-select"
            : qType === 9
            ? "Word association"
            : "Question"}
        </Text>
      </TouchableOpacity>
    );
  }

  // ─────────────────────────────────────────
  // FULL CARD (your original block, with tiny adjustments)
  // ─────────────────────────────────────────
  return (
    <TouchableOpacity
      key={index}
      onPress={() => toggleQuestionSelection(questionId)}
      style={[
        styles(isDarkMode).quizCardContainer,
        isPicked && { borderColor: "#AB274F", borderWidth: 2 },
      ]}
    >
      {/* header row */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 6,
        }}
      >
        <Text style={{ fontWeight: "600" }}>Q{index + 1}</Text>
        {!!difficultyLabel && (
          <View
            style={{
              paddingVertical: 2,
              paddingHorizontal: 6,
              borderRadius: 999,
              backgroundColor: badgeColor,
            }}
          >
            <Text
              style={{
                fontSize: 10,
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              {difficultyLabel}
            </Text>
          </View>
        )}
      </View>

      {/* Question Text */}
      <Text style={styles(isDarkMode).quizQuestion}>
        {fullText}
      </Text>

      {/* Question Images */}
      {question.question?.images?.length > 0 &&
        question.question.images.map((image, imgIndex) => (
          <Image
            key={imgIndex}
            source={{ uri: image.base64 }}
            style={{
              width:
                image.width < 150
                  ? image.width
                  : image.orientation === "horizontal"
                  ? "100%"
                  : "50%",
              height:
                image.height < 150
                  ? image.height
                  : image.orientation === "vertical"
                  ? 300
                  : 250,
              resizeMode: "contain",
              marginVertical: 5,
            }}
          />
        ))}

      {/* Question Types */}
      {qType === 1 ? (
        <>
          {question.word_bank?.length > 0 && (
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                marginBottom: 10,
              }}
            >
              <Text style={{ fontWeight: "bold", marginRight: 5 }}>
                🧩 Word Bank:
              </Text>
              {question.word_bank.map((word, idx) => (
                <Text
                  key={idx}
                  style={{
                    backgroundColor: "#eee",
                    paddingHorizontal: 8,
                    paddingVertical: 4,
                    borderRadius: 4,
                    marginRight: 8,
                    marginBottom: 6,
                  }}
                >
                  {word}
                </Text>
              ))}
            </View>
          )}

          <TextInput
            style={styles(isDarkMode).inputField}
            placeholder={t("Type your answer...")}
            value={userAnswers?.[questionId] || ""}
            onChangeText={(text) => handleAnswerChange(questionId, text)}
            onBlur={() =>
              checkTextAnswer(questionId, question.options?.correct_answer)
            }
          />
        </>
      ) : qType === 2 ? (
        <View>
          {["option1", "option2", "option3", "option4"].map(
            (optKey, idx) => {
              const option = question.options?.[optKey];
              if (!option) return null;

              const isSelected = userAnswers?.[questionId] === optKey;
              const isCorrect = answerFeedback?.[questionId] === "correct";

              return (
                <TouchableOpacity
                  key={idx}
                  style={[
                    styles(isDarkMode).quizOption,
                    isSelected &&
                      (isCorrect
                        ? styles(isDarkMode).correctAnswer
                        : styles(isDarkMode).wrongAnswer),
                  ]}
                  onPress={() =>
                    handleMCQSelection(
                      questionId,
                      optKey,
                      idx,
                      `${question.options?.correct_answer}`
                    )
                  }
                >
                  <Text style={styles(isDarkMode).optionText}>
                    Option {idx + 1}: {option.text}
                  </Text>
                  {option.images?.length > 0 &&
                    option.images.map((img, imgIdx) => (
                      <Image
                        key={imgIdx}
                        source={{ uri: img.base64 }}
                        style={{
                          width:
                            img.width < 150
                              ? img.width
                              : img.orientation === "horizontal"
                              ? "100%"
                              : "50%",
                          height:
                            img.height < 150
                              ? img.height
                              : img.orientation === "vertical"
                              ? 300
                              : 250,
                          resizeMode: "contain",
                          marginVertical: 5,
                        }}
                      />
                    ))}
                </TouchableOpacity>
              );
            }
          )}
        </View>
      ) : qType === 4 ? (
        <View>
          {["True", "False"].map((option, idx) => (
            <TouchableOpacity
              key={idx}
              style={[
                styles(isDarkMode).quizOption,
                userAnswers?.[questionId] === option &&
                  (option === question.options?.correct_answer
                    ? styles(isDarkMode).correctAnswer
                    : styles(isDarkMode).wrongAnswer),
              ]}
              onPress={() =>
                handleMCQSelection(
                  questionId,
                  option,
                  question.options?.correct_answer
                )
              }
            >
              <Text>{t("option")}</Text>
            </TouchableOpacity>
          ))}
        </View>
      ) : qType === 9 ? (
        renderWordAssociationBlock(question, index)
      ) : null}

      {/* Hint */}
      {(question.hints?.hint1?.text ||
        question.hints?.hint2?.text ||
        question.hints?.hint1?.images?.length ||
        question.hints?.hint2?.images?.length) && (
        <TouchableOpacity
          onPress={() => toggleHint(questionId)}
          style={styles(isDarkMode).hintButton}
        >
          <Text style={styles(isDarkMode).hintText}>
            <MaterialCommunityIcons
              name="lightbulb-outline"
              size={18}
              color="#FFF"
            />{" "}
            {t("Show Hint")}
          </Text>
        </TouchableOpacity>
      )}

      {showHints?.[questionId] && (
        <View>
          <Text style={styles(isDarkMode).hintText}>
            {question.hints?.hint1?.text || ""}{" "}
            {question.hints?.hint2?.text || ""}
          </Text>
          {[...(question.hints?.hint1?.images || []),
            ...(question.hints?.hint2?.images || []),
          ].map((image, imgIndex) => (
            <Image
              key={imgIndex}
              source={{ uri: image.base64 }}
              style={{
                width:
                  image.width < 150
                    ? image.width
                    : image.orientation === "horizontal"
                    ? "100%"
                    : "50%",
                height:
                  image.height < 150
                    ? image.height
                    : image.orientation === "vertical"
                    ? 300
                    : 250,
                resizeMode: "contain",
                marginVertical: 5,
              }}
            />
          ))}
        </View>
      )}

      {/* Solution Button */}
      <TouchableOpacity
        onPress={() => toggleSolution(questionId)}
        style={styles(isDarkMode).solutionButton}
      >
        <Text style={styles(isDarkMode).solutionButtonText}>
          <MaterialCommunityIcons
            name="lightbulb-on-outline"
            size={18}
            color="#FFF"
          />{" "}
          {t("Show Solution")}
        </Text>
      </TouchableOpacity>

      {/* Solution Text */}
      {showSolutions?.[questionId] && (
        <View>
          <Text style={styles(isDarkMode).solutionText}>
            {question.solution?.text || t("No solution available")}
          </Text>
          {question.solution?.images?.length > 0 &&
            question.solution.images.map((image, imgIndex) => (
              <Image
                key={imgIndex}
                source={{ uri: image.base64 }}
                style={{
                  width:
                    image.width < 150
                      ? image.width
                      : image.orientation === "horizontal"
                      ? "100%"
                      : "50%",
                  height:
                    image.height < 150
                      ? image.height
                      : image.orientation === "vertical"
                      ? 300
                      : 250,
                  resizeMode: "contain",
                  marginTop: 5,
                }}
              />
            ))}
        </View>
      )}
    </TouchableOpacity>
  );
};


const renderCurriculumTree = () => {
    return curriculum.map((level) => (
      <View key={level.id} style={styles(isDarkMode).levelContainer}>
        <Text style={styles(isDarkMode).levelTitle}>{t("Grade")} {level.grade}</Text>
        {level.subjects.map((subject) => (
          <View key={subject.id} style={styles(isDarkMode).subjectContainer}>
            <TouchableOpacity onPress={() => toggleExpandSubject(level.id, subject.id)}>
              <Text style={styles(isDarkMode).subjectTitle}>{subject.name}</Text>
            </TouchableOpacity>
            {expandedSubjects[level.id]?.[subject.id] && subject.chapters.map((chapter) => (
              <View key={chapter.id} style={styles(isDarkMode).chapterContainer}>
                <TouchableOpacity onPress={() => toggleExpandChapter(subject.id, chapter.id)}>
                  <Text style={styles(isDarkMode).chapterTitle}>
                    {expandedChapters[subject.id]?.[chapter.id] ? '🔽' : '▶'} {chapter.name}
                  </Text>
                </TouchableOpacity>
                {expandedChapters[subject.id]?.[chapter.id] && chapter.topics.map((topic) => (
                  <View
                    key={topic.id}
                    style={[
                      styles(isDarkMode).topicTitleItem,
                      activeTopic === `${chapter.id}-${topic.id}` ? styles(isDarkMode).activeItem : {}
                    ]}
                  >
                    <TouchableOpacity onPress={() => toggleTopicSelection(chapter.id, topic.id)}>
                      <Text
                        style={[
                          styles(isDarkMode).topicTitle,
                          selectedTopics.has(`${chapter.id}-${topic.id}`) && {
                            color: "#AB274F",
                            fontWeight: "bold"
                          }
                        ]}
                      >
                        {expandedTopics[chapter.id]?.[topic.id]?.expanded ? '🔽' : '▶'} {topic.name}
                      </Text>
                    </TouchableOpacity>
                  </View>
                ))}
              </View>
            ))}
          </View>
        ))}
      </View>
    ));
  };
// const renderCurriculumTree = () => {
//   return curriculum.map((level) => (
//     <View key={level.id} style={styles(isDarkMode).levelContainer}>
//       <Text style={styles(isDarkMode).levelTitle}>{t("Grade")} {level.grade}</Text>

//       {level.subjects.map((subject) => (
//         <View key={subject.id} style={styles(isDarkMode).subjectContainer}>
//           <TouchableOpacity onPress={() => toggleExpandSubject(level.id, subject.id)}>
//             <Text style={styles(isDarkMode).subjectTitle}>{subject.name}</Text>
//           </TouchableOpacity>

//           {expandedSubjects[level.id]?.[subject.id] && subject.chapters.map((chapter) => (
//             <View key={chapter.id} style={styles(isDarkMode).chapterContainer}>
//               <TouchableOpacity onPress={() => toggleExpandChapter(subject.id, chapter.id)}>
//                 <Text style={styles(isDarkMode).chapterTitle}>
//                   {expandedChapters[subject.id]?.[chapter.id] ? '🔽' : '▶'} {chapter.name}
//                 </Text>
//               </TouchableOpacity>

//               {expandedChapters[subject.id]?.[chapter.id] && chapter.topics.map((topic) => (
//                 <View
//                   key={topic.id}
//                   style={[
//                     styles(isDarkMode).topicTitleItem,
//                     activeTopic === `${chapter.id}-${topic.id}` ? styles(isDarkMode).activeItem : {}
//                   ]}
//                 >
//                   <TouchableOpacity onPress={() => toggleExpandTopic(chapter.id, topic.id)}>
//                     <Text
//                       style={[
//                         styles(isDarkMode).topicTitle,
//                         selectedTopics.has(`${chapter.id}-${topic.id}`) && {
//                           color: "#AB274F",
//                           fontWeight: "bold"
//                         }
//                       ]}
//                     >
//                       {expandedTopics[chapter.id]?.[topic.id]?.expanded ? '🔽' : '▶'} {topic.name}
//                     </Text>
//                   </TouchableOpacity>

//                   {/* ▶️ Expand and show Videos & PWOs */}
//                   {expandedTopics[chapter.id]?.[topic.id]?.expanded && (
//                     <View style={styles(isDarkMode).contentSection}>

//                       {/* 🎬 Videos */}
//                       {expandedTopics[chapter.id][topic.id]?.videos?.length > 0 && (
//                         <View>
//                           <Text style={styles(isDarkMode).sectionTitle}>🎬 {t("Videos")}</Text>
//                           {expandedTopics[chapter.id][topic.id].videos.map((video) => {
//                             const key = `${video.source_id}-${video.tag_id}`;
//                             const isSelected = selectedVideos.has(key);
//                             return (
//                               <TouchableOpacity key={key} onPress={() => toggleVideoSelection(video.source_id, video.tag_id)}>
//                                 <Text style={[
//                                   styles(isDarkMode).contentItem,
//                                   isSelected ? { color: "#2196F3", fontWeight: "bold" } : {}
//                                 ]}>
//                                   {video.name} — {video.tag_name} {isSelected ? "✅" : ""}
//                                 </Text>
//                               </TouchableOpacity>
//                             );
//                           })}
//                         </View>
//                       )}

//                       {/* 🎮 PWOs */}
//                       {expandedTopics[chapter.id][topic.id]?.pwos?.length > 0 && (
//                         <View>
//                           <Text style={styles(isDarkMode).sectionTitle}>🎮 {t("Interactive PWOs")}</Text>
//                           {expandedTopics[chapter.id][topic.id].pwos.map((pwo) => {
//                             const key = `${pwo.pwo_source_id}-${pwo.scene_name}`;
//                             const isSelected = selectedPWOs.has(key);
//                             return (
//                               <TouchableOpacity key={key} onPress={() => togglePWOSelection(pwo.pwo_source_id, pwo.scene_name)}>
//                                 <Text style={[
//                                   styles(isDarkMode).contentItem,
//                                   isSelected ? { color: "#4CAF50", fontWeight: "bold" } : {}
//                                 ]}>
//                                   {pwo.name} — {pwo.scene_name} {isSelected ? "✅" : ""}
//                                 </Text>
//                               </TouchableOpacity>
//                             );
//                           })}
//                         </View>
//                       )}
//                     </View>
//                   )}
//                 </View>
//               ))}
//             </View>
//           ))}
//         </View>
//       ))}
//     </View>
//   ));
// };

  // BDD 10/23/2025 - TestPrep
/* ======================= 4) UI: SCOPE PICKER (place above your curriculum tree) ======================= */
// Render chip rows with multi‑select behavior
// function Chip({active, label, onPress}) {
//   return (
//     <TouchableOpacity onPress={onPress} style={{paddingVertical:6,paddingHorizontal:10,borderRadius:999,margin:4, borderWidth:1, borderColor: active?"#4f46e5":"#999", backgroundColor: active?"#eef2ff":"#1110"}}>
//       <Text style={{fontSize:12,opacity:0.9}}>{label}</Text>
//     </TouchableOpacity>
//   );
// }

const scopePickerContent = (
    <View style={{padding:12, borderWidth:1, borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e5e7eb", borderRadius:12, marginBottom:12, backgroundColor: isDarkMode ? "#1e293b" : undefined}}>
      <Text style={{fontWeight:"600", marginBottom:6, color: isDarkMode ? "#f1f5f9" : undefined}}>Scope: Grades • Subjects • Chapters • Collections</Text>

      {/* Grades */}
      <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
        {(levels || []).map(l => (
          <Chip
            key={l.id}
            variant="grade"
            label={`Grade ${l.grade ?? l.id}`}
            active={gradeFilter.has(l.id)}
            onPress={() => toggleInSet(setGradeFilter, l.id)}
            isDarkMode={isDarkMode}
          />
        ))}
      </View>

      {/* Subjects */}
      <View style={{ flexDirection: "row", flexWrap: "wrap", marginTop: 6 }}>
        {levels
          .filter(l => !gradeFilter.size || gradeFilter.has(l.id))
          .flatMap(l => (subjectsByLevel.get(l.id) || []))
          .map(s => (
            <Chip
              key={s.id}
              variant="subject"
              label={s.name}
              active={subjectFilter.has(s.id)}
              onPress={() => toggleInSet(setSubjectFilter, s.id)}
              isDarkMode={isDarkMode}
            />
          ))}
      </View>

      {/* Chapters */}
      <View style={{ marginTop: 6 }}>
        {levels
          .filter(l => !gradeFilter.size || gradeFilter.has(l.id))
          .flatMap(l => (subjectsByLevel.get(l.id) || []))
          .filter(s => !subjectFilter.size || subjectFilter.has(s.id))
          .flatMap(s => (chaptersBySubject.get(s.id) || []))
          .map(ch => (
            <View key={ch.id} style={{ marginVertical: 4, marginLeft: 8 }}>
              <View style={{ flexDirection: "row", alignItems: "center", flexWrap: "wrap" }}>
                <Chip
                  variant="chapter"
                  label={ch.name}
                  active={chapterFilter.has(ch.id)}
                  onPress={() => toggleInSet(setChapterFilter, ch.id)}
                  isDarkMode={isDarkMode}
                />
                <TouchableOpacity onPress={() => addAllChapterTopics(ch.id)} style={{ marginLeft: 8 }}>
                  <Text style={{ fontSize: 12, textDecorationLine: "underline", color: isDarkMode ? "#94a3b8" : undefined }}>Select all topics</Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => removeAllChapterTopics(ch.id)} style={{ marginLeft: 8 }}>
                  <Text style={{ fontSize: 12, textDecorationLine: "underline", color: isDarkMode ? "#94a3b8" : undefined }}>Clear</Text>
                </TouchableOpacity>
              </View>

              {/* Topics under this chapter */}
              {chapterFilter.has(ch.id) && (
                <View style={{ flexDirection: "row", flexWrap: "wrap", marginLeft: 16 }}>
                  {(topicsByChapter.get(ch.id) || []).map(t => (
                    <Chip
                      key={t.id}
                      variant="topic"
                      label={t.name || `Topic ${t.id}`}
                      active={selectedTopics.has(`${ch.id}-${t.id}`)}
                      onPress={() => toggleTopicSelection(ch.id, t.id)}
                      isDarkMode={isDarkMode}
                    />
                  ))}
                </View>
              )}
            </View>
          ))}
      </View>

      {/* Collections */}
      <View style={{ marginTop: 10 }}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text style={{ fontWeight: "600", color: isDarkMode ? "#f1f5f9" : undefined }}>
            Collections <Text style={{ fontWeight: "400", opacity: 0.7 }}>({boardKey.toUpperCase()})</Text>
          </Text>
          <TouchableOpacity onPress={ensureCollectionsLoaded} style={{ marginLeft: 10 }}>
            <Text style={{ fontSize: 12, textDecorationLine: "underline", color: isDarkMode ? "#94a3b8" : undefined }}>Load</Text>
          </TouchableOpacity>
        </View>

        {/* vertical list so each collection can show its topics underneath */}
        <View style={{ marginTop: 6 }}>
          {collectionsForBoard.map((c) => {
            const isSelected = collectionFilter.has(c.id);
            const rows = topicsByCollection[c.id]; // 'loading' | undefined | [] | [{chapter_id, topic_id, name}]
            return (
              <View key={c.id} style={{ marginVertical: 6, marginLeft: 8 }}>
                {/* header row: chip + actions */}
                <View style={{ flexDirection: "row", alignItems: "center", flexWrap: "wrap" }}>
                  <Chip
                    variant="collection"
                    label={c.name}
                    active={isSelected}
                    isDarkMode={isDarkMode}
                    onPress={() => {
                      const wasSelected = collectionFilter.has(c.id);
                      toggleInSet(setCollectionFilter, c.id);
                      if (!wasSelected) ensureCollectionTopics(c.id); // load topics when turning ON
                    }}
                  />

                  {isSelected && (
                    <>
                      <TouchableOpacity
                        onPress={() => {
                          ensureCollectionTopics(c.id);
                          addAllCollectionTopics(c.id);
                        }}
                        style={{ marginLeft: 8 }}
                      >
                        <Text style={{ fontSize: 12, textDecorationLine: "underline", color: isDarkMode ? "#94a3b8" : undefined }}>Select all topics</Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          ensureCollectionTopics(c.id);
                          removeAllCollectionTopics(c.id);
                        }}
                        style={{ marginLeft: 8 }}
                      >
                        <Text style={{ fontSize: 12, textDecorationLine: "underline", color: isDarkMode ? "#94a3b8" : undefined }}>Clear</Text>
                      </TouchableOpacity>
                    </>
                  )}
                </View>

                {/* topics for this collection (same indent/color as chapter → topics) */}
                {isSelected && (
                  <View style={{ marginLeft: 16, marginTop: 4 }}>
                    {(!rows || rows === "loading") && (
                      <Text style={{ fontSize: 12, opacity: 0.7, color: isDarkMode ? "#94a3b8" : undefined }}>Loading topics…</Text>
                    )}

                    {Array.isArray(rows) && rows.length === 0 && (
                      <Text style={{ fontSize: 12, opacity: 0.7, color: isDarkMode ? "#94a3b8" : undefined }}>No topics in this collection.</Text>
                    )}

                    {Array.isArray(rows) && rows.length > 0 && (
                      <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                        {rows.map((t) => (
                          <Chip
                            key={`c${c.id}-t${t.topic_id}`}
                            variant="topic"
                            label={t.name}
                            active={selectedTopics.has(`${t.chapter_id}-${t.topic_id}`)}
                            onPress={() => toggleTopicSelection(t.chapter_id, t.topic_id)}
                            isDarkMode={isDarkMode}
                          />
                        ))}
                      </View>
                    )}
                  </View>
                )}
              </View>
            );
          })}
        </View>
      </View>

      {/* Selection summary */}
      <View style={{marginTop:12, padding:8, backgroundColor: isDarkMode ? "#0f172a" : "#f9fafb", borderRadius:8}}>
        <Text style={{fontSize:12, color: isDarkMode ? "#f1f5f9" : undefined}}>Selected: {selectedTopics.size} topic(s)</Text>
        {!!selectedTopics.size && (
          <TouchableOpacity onPress={() => setSelectedTopics(new Set())} style={{marginTop:4}}>
            <Text style={{fontSize:12, textDecorationLine:"underline", color: isDarkMode ? "#94a3b8" : undefined}}>Clear all</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );

// In your question renderer, add a checkbox/toggle that calls toggleQuestionPick(question.question_id)
// BDD 10/23/2025 - TestPrep
/* ======================= 8) AUTO‑COMPOSE BY DIFFICULTY ======================= */
async function autoComposeByDifficulty() {
  if (!selectedTopics.size) { Alert.alert("Select at least one topic first."); return; }
  const selectedPairs = Array.from(selectedTopics).map(key => { const [chapter_id, topic_id] = key.split("-"); return { chapter_id: Number(chapter_id), topic_id: Number(topic_id) }; });
  setLoading(true);
  try {
    const resp = await axios.post(`${FASTAPI_BASE_URL}/question-bank/auto_compose`, {
      pairs: selectedPairs,
      counts: { easy: Number(autoEasy)||0, medium: Number(autoMedium)||0, difficult: Number(autoDifficult)||0 },
      language_id: languageIDquiz,
    });
    const parsed = Array.isArray(resp?.data?.quiz) ? resp.data.quiz : [];
    setQuiz(parsed);
    setSelectedQuestionIds(new Set(parsed.map(q => String(q.question_id))));
  } catch(e) {
    console.error("auto_compose failed; falling back to client pick", e);
    // Optional fallback: if candidateQuestions contain difficulty tags, pick locally
    const buckets = { easy: [], medium: [], difficult: [] };
    for (const q of (quiz || [])) {
      const lvl = Number(q.difficulty_level ?? q.difficulty ?? 0);
      if (lvl === 1) buckets.easy.push(q);
      else if (lvl === 2) buckets.medium.push(q);
      else if (lvl === 3) buckets.difficult.push(q);
      else buckets.medium.push(q);
    }
    function take(arr, n) { return arr.slice(0, Math.max(0, n)); }
    const chosen = [...take(buckets.easy, autoEasy), ...take(buckets.medium, autoMedium), ...take(buckets.difficult, autoDifficult)];
    setQuiz(chosen);
    setSelectedQuestionIds(new Set(chosen.map(q => String(q.question_id))));
  } finally { setLoading(false); }
}

// BDD 10/23/2025 - TestPrep
/* ======================= 9) PUBLISH & SHARE FOR TESTS ======================= */
// Reusable card adapted from CollectionBuilder. Uses test‑specific endpoints via axios.
// function PublishShareTestCard({ testId, isPublished, onChangePublished }) {
//   const [visLocal, setVisLocal] = useState(isPublished ? "org" : "private"); // private|org|public
//   const [shares, setShares] = useState([]); // [{student_email}]
//   const [shareInput, setShareInput] = useState("");
//   const [savingVis, setSavingVis] = useState(false);
//   const [isSavingShare, setIsSavingShare] = useState(false);

//   useEffect(() => {
//     if (!testId) return;
//     let ignore = false;

//     async function loadScope() {
//       try {
//         // fetch test details so the pill reflects actual server state
//         const { data } = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}`);
//         const t = data?.test || {};
//         const serverScope = t.is_published ? (t.published_scope || "org") : "private";
//         if (!ignore) {
//           setVisLocal(serverScope);
//           // sync parent if its boolean disagrees with server
//           if (typeof onChangePublished === "function" &&
//               (!!isPublished !== (serverScope !== "private"))) {
//             onChangePublished(serverScope !== "private");
//           }
//         }
//       } catch {
//         // fallback to prop if fetch fails
//         if (!ignore) setVisLocal(isPublished ? "org" : "private");
//       }
//     }

//     loadScope();
//     return () => { ignore = true; };
//   }, [testId]); // (we read server when test changes)

//   useEffect(() => { if (testId) listShares(); }, [testId]);

//   function parseEmails(text) {
//     return (text||"").split(/[\s,;]+/).map(s => s.trim().toLowerCase()).filter(Boolean);
//   }

//   async function listShares() {
//     try {
//       const { data } = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}/shares`);
//       setShares(Array.isArray(data) ? data : []);
//     } catch(e) { console.warn("listShares failed", e); setShares([]); }
//   }
//   async function addShares() {
//     const emails = parseEmails(shareInput); if (!emails.length) return;
//     setIsSavingShare(true);
//     try {
//       await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, { student_emails: emails });
//       setShareInput(""); await listShares();
//     } catch(e) { Alert.alert("Error", "Could not add students."); } finally { setIsSavingShare(false); }
//   }
//   async function revokeShare(email) {
//     try {
//       await axios.delete(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, { data: { student_email: email } });
//       setShares(prev => prev.filter(s => s.student_email !== email));
//     } catch(e) { Alert.alert("Error", "Could not remove student."); }
//   }
//   async function assignSameDomain() {
//     try { await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/assign_same_domain`); await listShares(); }
//     catch(e) { Alert.alert("Error", "Could not share with your school domain."); }
//   }
//   async function changeVisibility(next) {
//     if (savingVis) return; setSavingVis(true); setVisLocal(next);
//     try {
//       if (next === "private") await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/unpublish`);
//       else await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/publish`, { scope: next });
//       onChangePublished?.(next !== "private");
//     } catch(e) { Alert.alert("Error", "Could not update visibility."); }
//     finally { setSavingVis(false); }
//   }

//   return (
//     <View style={{marginTop:12, padding:12, borderWidth:1, borderColor:"#e5e7eb", borderRadius:12}}>
//       <Text style={{fontWeight:"600", marginBottom:8}}>Publish & Share</Text>

//       {/* Visibility segment */}
//       <View style={{flexDirection:"row", marginBottom:8}}>
//         {["private","org","public"].map(v => (
//           <TouchableOpacity key={v} onPress={() => changeVisibility(v)} disabled={savingVis} style={{paddingVertical:6, paddingHorizontal:10, borderRadius:999, borderWidth:1, marginRight:6, borderColor: visLocal===v?"#4f46e5":"#cbd5e1", backgroundColor: visLocal===v?"#eef2ff":"#fff"}}>
//             <Text style={{fontSize:12}}>{v === "org" ? "School/Org" : v[0].toUpperCase()+v.slice(1)}</Text>
//           </TouchableOpacity>
//         ))}
//       </View>

//       <Text style={{fontSize:12, marginBottom:4}}>Share with specific students (emails)</Text>
//       <TextInput value={shareInput} onChangeText={setShareInput} placeholder="alice@school.org, bob@school.org …" multiline style={{minHeight:60, padding:8, borderWidth:1, borderColor:"#e5e7eb", borderRadius:8}} />
//       <View style={{flexDirection:"row", marginTop:6}}>
//         <TouchableOpacity onPress={addShares} disabled={isSavingShare || !shareInput.trim()} style={{paddingVertical:8, paddingHorizontal:14, borderRadius:8, backgroundColor:"#111827"}}>
//           <Text style={{color:"#fff"}}>{isSavingShare?"Saving…":"Add Students"}</Text>
//         </TouchableOpacity>
//         <TouchableOpacity onPress={assignSameDomain} style={{marginLeft:8, paddingVertical:8, paddingHorizontal:14, borderRadius:8, borderWidth:1, borderColor:"#e5e7eb"}}>
//           <Text>Share with my school</Text>
//         </TouchableOpacity>
//       </View>

//       {!!shares.length && (
//         <View style={{marginTop:10}}>
//           {shares.map(s => (
//             <View key={s.student_email} style={{flexDirection:"row", alignItems:"center", justifyContent:"space-between", paddingVertical:6, borderBottomWidth:1, borderColor:"#f3f4f6"}}>
//               <Text style={{fontSize:12}}>{s.student_email}</Text>
//               <TouchableOpacity onPress={() => revokeShare(s.student_email)}><Text style={{fontSize:12, color:"#dc2626"}}>Remove</Text></TouchableOpacity>
//             </View>
//           ))}
//         </View>
//       )}
//     </View>
//   );
// }
// BDD 10/23/2025 - individual publish and share of tests
// function PublishShareTestCard({ testId, isPublished, onChangePublished }) {
//   const [visLocal, setVisLocal] = useState(isPublished ? "org" : "private"); // private|org|public
//   const [shares, setShares] = useState([]); // [{student_email}]
//   const [shareInput, setShareInput] = useState("");
//   const [savingVis, setSavingVis] = useState(false);
//   const [isSavingShare, setIsSavingShare] = useState(false);

//   // Web-safe alert helper (optional)
//   const infoAlert = (title, msg) => {
//     if (Platform?.OS === "web" && typeof window !== "undefined") {
//       window.alert(`${title}\n\n${msg || ""}`);
//     } else {
//       Alert.alert(title, msg);
//     }
//   };

//   // ⬇️ Load scope from server so the pill reflects actual state
//   useEffect(() => {
//     if (!testId) return;
//     let ignore = false;

//     (async function loadScope() {
//       try {
//         const { data } = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}`);
//         const t = data?.test || {};
//         const serverScope = t.is_published ? (t.published_scope || "org") : "private";
//         if (!ignore) {
//           setVisLocal(serverScope);
//           if (typeof onChangePublished === "function" &&
//               (!!isPublished !== (serverScope !== "private"))) {
//             onChangePublished(serverScope !== "private");
//           }
//         }
//       } catch {
//         if (!ignore) setVisLocal(isPublished ? "org" : "private");
//       }
//     })();

//     return () => { ignore = true; };
//   }, [testId]);

//   // ⬇️ Shares list on test change
//   useEffect(() => { if (testId) listShares(); }, [testId]);

//   // Simple email parser (keeps your behavior, adds basic validation)
//   function parseEmails(text) {
//     const tokens = String(text || "").replace(/\r/g, "\n").split(/[\s,;]+/);
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const seen = new Set(); const out = [];
//     for (const tok of tokens) {
//       const e = tok.trim().toLowerCase();
//       if (e && re.test(e) && !seen.has(e)) { seen.add(e); out.push(e); }
//     }
//     return out;
//   }

//   async function listShares() {
//     try {
//       const { data } = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}/shares`);
//       setShares(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.warn("listShares failed", e);
//       setShares([]);
//     }
//   }

//   async function addShares() {
//     const emails = parseEmails(shareInput);
//     if (!emails.length) return;
//     setIsSavingShare(true);
//     try {
//       await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, { student_emails: emails });
//       setShareInput("");
//       await listShares();
//     } catch (e) {
//       infoAlert("Error", "Could not add students.");
//     } finally {
//       setIsSavingShare(false);
//     }
//   }

//   async function revokeShare(email) {
//     try {
//       await axios.delete(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, { data: { student_email: email } });
//       setShares(prev => prev.filter(s => s.student_email !== email));
//     } catch (e) {
//       infoAlert("Error", "Could not remove student.");
//     }
//   }

//   async function assignSameDomain() {
//     try {
//       setIsSavingShare(true);
//       await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/assign_same_domain`);
//       // reflect published+org locally
//       setVisLocal("org");
//       onChangePublished?.(true);
//       await listShares();
//     } catch (e) {
//       infoAlert("Error", "Could not share with your school domain.");
//     } finally {
//       setIsSavingShare(false);
//     }
//   }

//   async function changeVisibility(next) {
//     if (savingVis) return;
//     setSavingVis(true);
//     const prev = visLocal;
//     setVisLocal(next); // optimistic
//     try {
//       if (next === "private") {
//         await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/unpublish`);
//         onChangePublished?.(false);
//       } else {
//         await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/publish`, { scope: next }); // "org" | "public"
//         onChangePublished?.(true);
//       }
//     } catch (e) {
//       setVisLocal(prev); // rollback if failed
//       infoAlert("Error", "Could not update visibility.");
//     } finally {
//       setSavingVis(false);
//     }
//   }

//   async function handleCsvFileChange(evt) {
//     try {
//       const file = evt.target?.files?.[0]; if (!file) return;
//       setIsSavingShare(true);
//       const text = await file.text();
//       const emails = parseEmails(text); // reuses your parser
//       if (!emails.length) { 
//         if (Platform?.OS === "web" && typeof window !== "undefined") {
//           window.alert("CSV\n\nNo emails found.");
//         } else {
//           Alert.alert("CSV", "No emails found.");
//         }
//         return;
//       }
//       await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, { student_emails: emails });
//       await listShares();
//     } catch (e) {
//       if (Platform?.OS === "web" && typeof window !== "undefined") {
//         window.alert("Error\n\nCould not process CSV.");
//       } else {
//         Alert.alert("Error", "Could not process CSV.");
//       }
//     } finally {
//       setIsSavingShare(false);
//       if (evt?.target) evt.target.value = ""; // reset file input
//     }
//   }

//   return (
//     <View style={{ marginTop: 12, padding: 12, borderWidth: 1, borderColor: "#e5e7eb", borderRadius: 12 }}>
//       <Text style={{ fontWeight: "600", marginBottom: 8 }}>Publish & Share</Text>

//       {/* Visibility segment */}
//       <View style={{ flexDirection: "row", marginBottom: 8 }}>
//         {["private", "org", "public"].map(v => (
//           <TouchableOpacity
//             key={v}
//             onPress={() => changeVisibility(v)}
//             disabled={savingVis}
//             style={{
//               paddingVertical: 6,
//               paddingHorizontal: 10,
//               borderRadius: 999,
//               borderWidth: 1,
//               marginRight: 6,
//               borderColor: visLocal === v ? "#4f46e5" : "#cbd5e1",
//               backgroundColor: visLocal === v ? "#eef2ff" : "#fff"
//             }}
//           >
//             <Text style={{ fontSize: 12 }}>{v === "org" ? "School/Org" : v[0].toUpperCase() + v.slice(1)}</Text>
//           </TouchableOpacity>
//         ))}
//       </View>

//       <Text style={{ fontSize: 12, marginBottom: 4 }}>Share with specific students (emails)</Text>
//       <TextInput
//         value={shareInput}
//         onChangeText={setShareInput}
//         placeholder="alice@school.org, bob@school.org …"
//         multiline
//         style={{ minHeight: 60, padding: 8, borderWidth: 1, borderColor: "#e5e7eb", borderRadius: 8 }}
//       />
//       <View style={{ flexDirection: "row", marginTop: 6 }}>
//         <TouchableOpacity
//           onPress={addShares}
//           disabled={isSavingShare || !shareInput.trim()}
//           style={{ paddingVertical: 8, paddingHorizontal: 14, borderRadius: 8, backgroundColor: "#111827" }}
//         >
//           <Text style={{ color: "#fff" }}>{isSavingShare ? "Saving…" : "Add Students"}</Text>
//         </TouchableOpacity>

//         <TouchableOpacity
//           onPress={assignSameDomain}
//           style={{ marginLeft: 8, paddingVertical: 8, paddingHorizontal: 14, borderRadius: 8, borderWidth: 1, borderColor: "#e5e7eb" }}
//         >
//           <Text>Share with my school</Text>
//         </TouchableOpacity>
//       </View>

//       {Platform.OS === "web" && (
//         <View style={{ marginTop: 6 }}>
//           <input type="file" accept=".csv,.txt" onChange={handleCsvFileChange} />
//           <Text style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>
//             Upload CSV/TXT with one or more emails (comma/space/newline separated)
//           </Text>
//         </View>
//       )}

//       {!!shares.length && (
//         <View style={{ marginTop: 10 }}>
//           {shares.map(s => (
//             <View
//               key={s.student_email}
//               style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingVertical: 6, borderBottomWidth: 1, borderColor: "#f3f4f6" }}
//             >
//               <Text style={{ fontSize: 12 }}>{s.student_email}</Text>
//               <TouchableOpacity onPress={() => revokeShare(s.student_email)}>
//                 <Text style={{ fontSize: 12, color: "#dc2626" }}>Remove</Text>
//               </TouchableOpacity>
//             </View>
//           ))}
//         </View>
//       )}
//     </View>
//   );
// }
// BDD 10/27/2025 - adding collabpisbility
// function PublishShareTestCard({ testId, isPublished, onChangePublished }) {
//   const [visLocal, setVisLocal] = useState(isPublished ? "org" : "private"); // "private" | "org" | "public"
//   const [shares, setShares] = useState([]); // [{student_email}]
//   const [shareInput, setShareInput] = useState("");
//   // const [savingVis, setSavingVis] = useState(false); // BDD 10/27/2025
//   const [isSavingShare, setIsSavingShare] = useState(false);

//   // NEW: collapsed/expanded
//   const [expanded, setExpanded] = useState(false); // default collapsed to save vertical space

//   // Web-safe alert helper
//   const infoAlert = (title, msg) => {
//     if (Platform?.OS === "web" && typeof window !== "undefined") {
//       window.alert(`${title}\n\n${msg || ""}`);
//     } else {
//       Alert.alert(title, msg);
//     }
//   };

//   // ⬇️ Load scope from server so the pill reflects actual state
//   useEffect(() => {
//     if (!testId) return;
//     let ignore = false;

//     (async function loadScope() {
//       try {
//         const { data } = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}`);
//         const t = data?.test || {};
//         const serverScope = t.is_published ? (t.published_scope || "org") : "private";

//         if (!ignore) {
//           setVisLocal(serverScope);

//           // sync parent if mismatch
//           if (
//             typeof onChangePublished === "function" &&
//             (!!isPublished !== (serverScope !== "private"))
//           ) {
//             onChangePublished(serverScope !== "private");
//           }
//         }
//       } catch {
//         if (!ignore) {
//           setVisLocal(isPublished ? "org" : "private");
//         }
//       }
//     })();

//     return () => {
//       ignore = true;
//     };
//   }, [testId]);

//   // ⬇️ Shares list on test change
//   useEffect(() => {
//     if (testId) listShares();
//   }, [testId]);

//   function parseEmails(text) {
//     const tokens = String(text || "").replace(/\r/g, "\n").split(/[\s,;]+/);
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const seen = new Set();
//     const out = [];
//     for (const tok of tokens) {
//       const e = tok.trim().toLowerCase();
//       if (e && re.test(e) && !seen.has(e)) {
//         seen.add(e);
//         out.push(e);
//       }
//     }
//     return out;
//   }

//   async function listShares() {
//     try {
//       const { data } = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}/shares`);
//       setShares(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.warn("listShares failed", e);
//       setShares([]);
//     }
//   }

//   async function addShares() {
//     const emails = parseEmails(shareInput);
//     if (!emails.length) return;
//     setIsSavingShare(true);
//     try {
//       await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, {
//         student_emails: emails,
//       });
//       setShareInput("");
//       await listShares();
//     } catch (e) {
//       infoAlert("Error", "Could not add students.");
//     } finally {
//       setIsSavingShare(false);
//     }
//   }

//   async function revokeShare(email) {
//     try {
//       await axios.delete(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, {
//         data: { student_email: email },
//       });
//       setShares((prev) => prev.filter((s) => s.student_email !== email));
//     } catch (e) {
//       infoAlert("Error", "Could not remove student.");
//     }
//   }

//   async function assignSameDomain() {
//     try {
//       setIsSavingShare(true);
//       await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/assign_same_domain`);

//       // reflect published+org locally
//       setVisLocal("org");
//       onChangePublished?.(true);

//       await listShares();
//     } catch (e) {
//       infoAlert("Error", "Could not share with your school domain.");
//     } finally {
//       setIsSavingShare(false);
//     }
//   }

//   async function changeVisibility(next) {
//     // if (savingVis) return;
//     // setSavingVis(true);

//     // const prev = visLocal;
//     setVisLocal(next); // BDD 10/27/2025

//     // BDD 10/27/2025
//     // do NOT call the backend here
//     // do NOT call onChangePublished here

//     // try {
//     //   if (next === "private") {
//     //     await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/unpublish`);
//     //     onChangePublished?.(false);
//     //   } else {
//     //     // "org" or "public"
//     //     await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/publish`, {
//     //       scope: next,
//     //     });
//     //     onChangePublished?.(true);
//     //   }
//     // } catch (e) {
//     //   // rollback if fail
//     //   setVisLocal(prev);
//     //   infoAlert("Error", "Could not update visibility.");
//     // } finally {
//     //   setSavingVis(false);
//     // }
//   }

//   async function handleCsvFileChange(evt) {
//     try {
//       const file = evt.target?.files?.[0];
//       if (!file) return;
//       setIsSavingShare(true);

//       const text = await file.text();
//       const emails = parseEmails(text);
//       if (!emails.length) {
//         infoAlert("CSV", "No emails found.");
//         return;
//       }

//       await axios.post(`${FASTAPI_BASE_URL}/tests/${testId}/shares`, {
//         student_emails: emails,
//       });

//       await listShares();
//     } catch (e) {
//       infoAlert("Error", "Could not process CSV.");
//     } finally {
//       setIsSavingShare(false);
//       if (evt?.target) evt.target.value = ""; // reset file input for web
//     }
//   }

//   // --- Small pill for current visibility, reused in header ---
//   function VisibilityPill() {
//     const labelMap = {
//       private: "Private",
//       org: "School/Org",
//       public: "Public",
//     };
//     return (
//       <View
//         style={{
//           paddingVertical: 2,
//           paddingHorizontal: 8,
//           borderRadius: 999,
//           borderWidth: 1,
//           borderColor: "#cbd5e1",
//           backgroundColor: visLocal === "private" ? "#fff" : "#eef2ff",
//         }}
//       >
//         <Text style={{ fontSize: 11, fontWeight: "500" }}>
//           {labelMap[visLocal] || visLocal}
//         </Text>
//       </View>
//     );
//   }

//   return (
//     <View
//       style={{
//         marginTop: 12,
//         borderWidth: 1,
//         borderColor: "#e5e7eb",
//         borderRadius: 12,
//         overflow: "hidden",
//       }}
//     >
//       {/* HEADER BAR (click to collapse/expand) */}
//       <TouchableOpacity
//         onPress={() => setExpanded((e) => !e)}
//         style={{
//           flexDirection: "row",
//           alignItems: "center",
//           justifyContent: "space-between",
//           paddingVertical: 10,
//           paddingHorizontal: 12,
//           backgroundColor: "#f9fafb",
//         }}
//       >
//         <View style={{ flexDirection: "row", alignItems: "center" }}>
//           <MaterialCommunityIcons
//             name={expanded ? "chevron-down" : "chevron-right"}
//             size={20}
//             color="#111"
//             style={{ marginRight: 6 }}
//           />
//           <Text style={{ fontWeight: "600", fontSize: 14 }}>
//             Publish & Share
//           </Text>
//         </View>

//         {/* show current visibility even when collapsed */}
//         <VisibilityPill />
//       </TouchableOpacity>

//       {/* BODY (only when expanded) */}
//       {expanded && (
//         <View style={{ padding: 12, borderTopWidth: 1, borderColor: "#e5e7eb" }}>
//           {/* Visibility segment */}
//           <View style={{ flexDirection: "row", marginBottom: 8, flexWrap: "wrap" }}>
//             {["private", "org", "public"].map((v) => (
//               <TouchableOpacity
//                 key={v}
//                 onPress={() => changeVisibility(v)}
//                 // disabled={savingVis} // BDD 10/27/2025
//                 style={{
//                   paddingVertical: 6,
//                   paddingHorizontal: 10,
//                   borderRadius: 999,
//                   borderWidth: 1,
//                   marginRight: 6,
//                   marginBottom: 6,
//                   borderColor: visLocal === v ? "#4f46e5" : "#cbd5e1",
//                   backgroundColor: visLocal === v ? "#eef2ff" : "#fff",
//                 }}
//               >
//                 <Text style={{ fontSize: 12 }}>
//                   {v === "org" ? "School/Org" : v[0].toUpperCase() + v.slice(1)}
//                 </Text>
//               </TouchableOpacity>
//             ))}
//           </View>

//           {/* Manual share entry */}
//           <Text style={{ fontSize: 12, marginBottom: 4 }}>
//             Share with specific students (emails)
//           </Text>
//           <TextInput
//             value={shareInput}
//             onChangeText={setShareInput}
//             placeholder="alice@school.org, bob@school.org …"
//             multiline
//             style={{
//               minHeight: 60,
//               padding: 8,
//               borderWidth: 1,
//               borderColor: "#e5e7eb",
//               borderRadius: 8,
//             }}
//           />
//           <View style={{ flexDirection: "row", marginTop: 6, flexWrap: "wrap" }}>
//             <TouchableOpacity
//               onPress={addShares}
//               disabled={isSavingShare || !shareInput.trim()}
//               style={{
//                 paddingVertical: 8,
//                 paddingHorizontal: 14,
//                 borderRadius: 8,
//                 backgroundColor: "#111827",
//               }}
//             >
//               <Text style={{ color: "#fff" }}>
//                 {isSavingShare ? "Saving…" : "Add Students"}
//               </Text>
//             </TouchableOpacity>

//             <TouchableOpacity
//               onPress={assignSameDomain}
//               style={{
//                 marginLeft: 8,
//                 paddingVertical: 8,
//                 paddingHorizontal: 14,
//                 borderRadius: 8,
//                 borderWidth: 1,
//                 borderColor: "#e5e7eb",
//               }}
//             >
//               <Text>Share with my school</Text>
//             </TouchableOpacity>
//           </View>

//           {/* CSV upload (web only) */}
//           {Platform.OS === "web" && (
//             <View style={{ marginTop: 10 }}>
//               <input
//                 type="file"
//                 accept=".csv,.txt"
//                 onChange={handleCsvFileChange}
//               />
//               <Text style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>
//                 Upload CSV/TXT with one or more emails (comma/space/newline
//                 separated)
//               </Text>
//             </View>
//           )}

//           {/* Shared list */}
//           {!!shares.length && (
//             <View style={{ marginTop: 12 }}>
//               {shares.map((s) => (
//                 <View
//                   key={s.student_email}
//                   style={{
//                     flexDirection: "row",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     paddingVertical: 6,
//                     borderBottomWidth: 1,
//                     borderColor: "#f3f4f6",
//                   }}
//                 >
//                   <Text style={{ fontSize: 12 }}>{s.student_email}</Text>
//                   <TouchableOpacity onPress={() => revokeShare(s.student_email)}>
//                     <Text style={{ fontSize: 12, color: "#dc2626" }}>
//                       Remove
//                     </Text>
//                   </TouchableOpacity>
//                 </View>
//               ))}
//             </View>
//           )}
//         </View>
//       )}
//     </View>
//   );
// }

/* ======================= 11) DELETE TEST BUTTON ======================= */
const handleDeleteTest = async () => {
  if (!selectedTest?.id) return;
  const id = selectedTest.id;
  const name = (testDetails?.title || selectedTest?.title || "Untitled").trim();

  // 🔐 Use either testDetails or selectedTest (whichever is accurate now)
  const publishedNow = (testDetails?.is_published ?? selectedTest?.is_published ?? false) === true;

  if (publishedNow) {
    // Alert for web + native (optional: switch to your Alert if you prefer)
    if (Platform.OS === "web" && typeof window !== "undefined") {
      window.alert("Unpublish required\n\nThis test is published. Please unpublish it first, then delete.");
    } else {
      Alert.alert("Unpublish required", "This test is published. Please unpublish it first, then delete.");
    }
    return;
  }

  // 2) Confirm
  const ok = await (typeof confirmDeleteDialog === "function"
    ? confirmDeleteDialog(`This will permanently delete "${name}" (ID ${id}).`)
    : true);
  if (!ok) return;

  // 3) Optimistic state
  setDeletingTestId(id);
  const prevTests = tests;
  const prevSelected = selectedTest;
  const prevQuiz = quiz;
  const prevSelectedIds = selectedQuestionIds;

  setTests(p => p.filter(t => t.id !== id));
  setSelectedTest(null);
  try { setSelectedTestId?.(null); } catch {}
  setTestDetails({ title: "", description: "", chapters: [], is_published: false });
  setQuiz([]);
  setSelectedQuestionIds(new Set());

  // 4) Call API
  try {
    await axios.delete(`${FASTAPI_BASE_URL}/tests/${id}`);
    // done
  } catch (e) {
    // If backend returns 400 because published, show exact message
    const msg = e?.response?.data?.detail || "Could not delete the test. Please try again.";
    Alert.alert("Delete failed", msg);

    // rollback
    setTests(prevTests);
    setSelectedTest(prevSelected);
    try { setSelectedTestId?.(prevSelected?.id ?? null); } catch {}
    setQuiz(prevQuiz);
    setSelectedQuestionIds(prevSelectedIds);
  } finally {
    setDeletingTestId(null);
  }
};

useEffect(() => {
  for (const cid of collectionFilter) {
    if (!topicsByCollection[cid]) {
      ensureCollectionTopics(cid);
    }
  }
}, [collectionFilter, topicsByCollection]);

// BDD 10/23/2025 - TestPrep - end

return (
    <View style={styles(isDarkMode).container}>

        <View style={styles(isDarkMode).contentWrapper}>
            {/* Sidebar with dynamic width BDD 10/17/2025 */}
            <View style={[styles(isDarkMode).sidebar, { width: sidebarWidth, flexShrink: 0 }]}>
                  {/* Sidebar Tab Navigation */}
                  <View style={{ flex: 1 }}>
                      <View style={styles(isDarkMode).tabContainer}>

                          <TouchableOpacity
                              style={[styles(isDarkMode).tab, activeSidebarTab === 'learning' && styles(isDarkMode).activeTab]}
                              onPress={() => setActiveSidebarTab('learning')}
                          >
                              <Text style={styles(isDarkMode).tabText}>{t("Select Topics for Test")}</Text>
                          </TouchableOpacity>

                      </View>

                      {/* Learning Path View */}
                      {activeSidebarTab === 'learning' && (
                          <ScrollView
                              contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
                              keyboardShouldPersistTaps="handled"
                              showsVerticalScrollIndicator={true}
                          >
                              <Text style={styles(isDarkMode).learningPathTitle}>{'📚'} {t("Topics for Test")}</Text>

                              {scopePickerContent}

                              <View>
                                  <Button mode="contained" onPress={fetchAdditionalQuestions} style={{ marginVertical: 10 }}>
                                      {t("Fetch Questions")}
                                  </Button>
                                  {/* 🤖 New: Auto-compose by difficulty (Easy/Medium/Difficult MCQ) BDD 10/23/2025 
                                  <View style={{ marginTop: 12, padding: 10, borderWidth: 1, borderColor: "#e5e7eb", borderRadius: 8 }}>
                                    <Text style={{ fontWeight: "600" }}>Auto-compose</Text>

                                    <View style={{ flexDirection: "row", alignItems: "center", marginTop: 8, flexWrap: "wrap", rowGap: 8 }}>
                                      <Text style={{ width: 70 }}>Easy</Text>
                                      <TextInput
                                        value={String(autoEasy)}
                                        onChangeText={(v) => setAutoEasy(Number(v) || 0)}
                                        keyboardType="numeric"
                                        style={{ width: 64, borderWidth: 1, borderColor: "#e5e7eb", padding: 4, borderRadius: 6 }}
                                      />

                                      <Text style={{ marginLeft: 10, width: 70 }}>Medium</Text>
                                      <TextInput
                                        value={String(autoMedium)}
                                        onChangeText={(v) => setAutoMedium(Number(v) || 0)}
                                        keyboardType="numeric"
                                        style={{ width: 64, borderWidth: 1, borderColor: "#e5e7eb", padding: 4, borderRadius: 6 }}
                                      />

                                      <Text style={{ marginLeft: 10, width: 70 }}>Difficult</Text>
                                      <TextInput
                                        value={String(autoDifficult)}
                                        onChangeText={(v) => setAutoDifficult(Number(v) || 0)}
                                        keyboardType="numeric"
                                        style={{ width: 64, borderWidth: 1, borderColor: "#e5e7eb", padding: 4, borderRadius: 6 }}
                                      />

                                      <Button
                                        mode="contained"
                                        onPress={() =>
                                          fetchAdditionalQuestions({
                                            auto: true,
                                            counts: { easy: Number(autoEasy) || 0, medium: Number(autoMedium) || 0, difficult: Number(autoDifficult) || 0 },
                                            mode: "preselect", // or "replace" if you want to show only the chosen ones
                                          })
                                        }
                                        style={{ marginLeft: 10, marginTop: 8 }}
                                      >
                                        🤖 Auto create by difficulty
                                      </Button>
                                    </View>
                                  </View>
                                  */}
                                  <View style={{ marginTop: 20, padding: 10, borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", borderRadius: 5, backgroundColor: isDarkMode ? "#1e293b" : undefined }}>
                                    <Text style={{ fontWeight: "bold", fontSize: 16, marginBottom: 5, color: isDarkMode ? "#f1f5f9" : undefined }}>
                                      🤖 AI Test Generator
                                    </Text>

                                    <TextInput
                                      placeholder="🎓 Grade (e.g. 7)"
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={String(aiGrade)}
                                      onChangeText={(text) => setAiGrade(text.replace(/[^\d]/g, ""))}
                                      keyboardType="numeric"
                                      style={{ borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", padding: 5, marginBottom: 5, color: isDarkMode ? "#f1f5f9" : undefined, backgroundColor: isDarkMode ? "#0f172a" : undefined }}
                                    />

                                    <TextInput
                                      placeholder="📈 Difficulty (easy / medium / hard)"
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={aiDifficulty}
                                      onChangeText={(text) => setAiDifficulty(text)}
                                      style={{ borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", padding: 5, marginBottom: 5, color: isDarkMode ? "#f1f5f9" : undefined, backgroundColor: isDarkMode ? "#0f172a" : undefined }}
                                    />

                                    <Text style={{ marginTop: 10, fontWeight: "bold", color: isDarkMode ? "#f1f5f9" : undefined }}>🔢 Number of Questions by Type</Text>

                                    <TextInput
                                      placeholder="❓ MCQ count"
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={String(aiCountMCQ)}
                                      onChangeText={(text) => setAiCountMCQ(text.replace(/[^\d]/g, ""))}
                                      keyboardType="numeric"
                                      style={{ borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", padding: 5, marginTop: 5, color: isDarkMode ? "#f1f5f9" : undefined, backgroundColor: isDarkMode ? "#0f172a" : undefined }}
                                    />

                                    <TextInput
                                      placeholder="✏️ Fill-in-the-blank count"
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={String(aiCountFill)}
                                      onChangeText={(text) => setAiCountFill(text.replace(/[^\d]/g, ""))}
                                      keyboardType="numeric"
                                      style={{ borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", padding: 5, marginTop: 5, color: isDarkMode ? "#f1f5f9" : undefined, backgroundColor: isDarkMode ? "#0f172a" : undefined }}
                                    />

                                    <TextInput
                                      placeholder="🔗 Word association count"
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={String(aiCountAssoc)}
                                      onChangeText={(text) => setAiCountAssoc(text.replace(/[^\d]/g, ""))}
                                      keyboardType="numeric"
                                      style={{ borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", padding: 5, marginTop: 5, color: isDarkMode ? "#f1f5f9" : undefined, backgroundColor: isDarkMode ? "#0f172a" : undefined }}
                                    />

                                    <TextInput
                                      placeholder="✍️ Short essay count (3–5 sentences)"
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={String(aiCountShortEssay)}
                                      onChangeText={(text) => setAiCountShortEssay(text.replace(/[^\d]/g, ""))}
                                      keyboardType="numeric"
                                      style={{ borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", padding: 5, marginTop: 5, color: isDarkMode ? "#f1f5f9" : undefined, backgroundColor: isDarkMode ? "#0f172a" : undefined }}
                                    />

                                    <TextInput
                                      placeholder="📝 Long essay count (150–200 words)"
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={String(aiCountLongEssay)}
                                      onChangeText={(text) => setAiCountLongEssay(text.replace(/[^\d]/g, ""))}
                                      keyboardType="numeric"
                                      style={{ borderWidth: 1, borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc", padding: 5, marginTop: 5, marginBottom: 10, color: isDarkMode ? "#f1f5f9" : undefined, backgroundColor: isDarkMode ? "#0f172a" : undefined }}
                                    />

                                    <TextInput
                                      placeholder="🧠 Paste lesson material or instructions for the AI..."
                                      placeholderTextColor={isDarkMode ? "#64748b" : undefined}
                                      value={aiInstructions}
                                      onChangeText={setAiInstructions}
                                      multiline
                                      numberOfLines={4}
                                      textAlignVertical="top"
                                      style={{
                                        borderWidth: 1,
                                        borderColor: isDarkMode ? "rgba(148,163,184,0.2)" : "#ccc",
                                        padding: 5,
                                        marginTop: 10,
                                        marginBottom: 10,
                                        height: 100,
                                        color: isDarkMode ? "#f1f5f9" : undefined,
                                        backgroundColor: isDarkMode ? "#0f172a" : undefined,
                                      }}
                                    />

                                    <Button mode="contained" onPress={handleGenerateAITest}>
                                      ⚙️ Generate AI Questions
                                    </Button>
                                  </View>

                                  <Text style={{ fontWeight: "bold", marginBottom: 10, color: isDarkMode ? "#f1f5f9" : undefined }}>{t("Existing Tests")}</Text>
                                  <ScrollView style={{ maxHeight: 200 }}>
                                      {tests.map((test) => (
                                      <TouchableOpacity key={test.id} onPress={() => handleSelectTest(test)}>
                                          <Text style={{ padding: 5, backgroundColor: selectedTest && selectedTest.id === test.id ? (isDarkMode ? "#334155" : "#ddd") : (isDarkMode ? "#1e293b" : "#fff"), color: isDarkMode ? "#f1f5f9" : undefined }}>
                                          {test.title || t("Untitled")} (ID: {test.id})
                                          </Text>
                                      </TouchableOpacity>
                                      ))}
                                  </ScrollView>
                                  <Button
                                  mode="contained"
                                  onPress={() => {
                                      // Clear selected test and test details.
                                      setSelectedTest(null);
                                      setTestDetails({ title: "", description: "", chapters: [] });
                                      // Clear the questions list and any pre-selected question IDs.
                                      setQuiz([]);
                                      setExistingTestQuestions([]);
                                      setSelectedQuestionIds(new Set());
                                  }}
                                  style={{ marginTop: 10 }}
                                  >
                                  {t("New Test")}
                                  </Button>
                              </View>

                          </ScrollView>
      
                      )}

  
                  </View>
            </View>

            {/* Draggable vertical bar BDD 10/17/2025 */}
            <View
              style={styles(isDarkMode).resizer}
              onMouseDown={beginResize}
              onTouchStart={beginResizeTouch}
              pointerEvents="box-only"
            >
              <View style={styles(isDarkMode).resizerHandle} />
            </View>

            <View style={styles(isDarkMode).mainContent}>
                {/* Close Button (Only Shows If a Module Is Active) */}
                {activeModule && (
                    <TouchableOpacity
                        onPress={handleCloseModule}
                        style={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            backgroundColor: "rgba(0,0,0,0.6)",
                            borderRadius: 20,
                            padding: 8,
                            zIndex: 10
                        }}
                    >
                        <MaterialCommunityIcons  name="close" size={18} color="white" />
                    </TouchableOpacity>
                )}
                {/* Status Message with Animation */}
                <View style={styles(isDarkMode).statusContainer}>
                    {loading && (
                        <Text style={styles(isDarkMode).loadingText}>
                            {t("Working on your query") + ".".repeat(loadingDots)}
                        </Text>
                    )}
                </View>
                <ScrollView
                  style={{ flex: 1 }}
                  contentContainerStyle={{ paddingBottom: 40 }}
                  showsVerticalScrollIndicator={true}
                >
                <View style={{ padding: 10, paddingTop: 0, marginBottom: 10, height:'unset'}}>
                <View style={{
                  marginTop: 10,
                  borderRadius: 16,
                  backgroundColor: isDarkMode ? "#1e293b" : "#ffffff",
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.06,
                  shadowRadius: 16,
                  elevation: 4,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#f3f4f6",
                }}>
                  <TouchableOpacity
                    onPress={() => setShowTestDetails(!showTestDetails)}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      paddingVertical: 16,
                      paddingHorizontal: 20,
                      backgroundColor: isDarkMode ? "#334155" : "#fafaf9",
                      borderBottomWidth: showTestDetails ? 1 : 0,
                      borderBottomColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e7e5e4",
                    }}
                  >
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                      <MaterialCommunityIcons
                        name="file-document-outline"
                        size={22}
                        color="#0d9488"
                        style={{ marginRight: 10 }}
                      />
                      <Text style={{
                        fontWeight: "700",
                        fontSize: 16,
                        color: isDarkMode ? "#f1f5f9" : "#1c1917",
                        letterSpacing: 0.2,
                      }}>
                        {showTestDetails ? t("Hide Test Details") : t("Show Test Details")}
                      </Text>
                      <MaterialCommunityIcons
                        name={showTestDetails ? "chevron-up" : "chevron-down"}
                        size={20}
                        color="#78716c"
                        style={{ marginLeft: 8 }}
                      />
                    </View>
                  </TouchableOpacity>

                  {showTestDetails && (
                    <View style={{ padding: 20, backgroundColor: isDarkMode ? "#1e293b" : "#ffffff" }}>
                      <TestDetailsForm
                        test_id={selectedTestId}
                        testDetails={testDetails}
                        setTestDetails={setTestDetails}
                        handleSaveTest={handleSaveTest}
                        showStartPicker={showStartPicker}
                        setShowStartPicker={setShowStartPicker}
                        showEndPicker={showEndPicker}
                        setShowEndPicker={setShowEndPicker}
                        isDarkMode={isDarkMode}
                        validationErrors={validationErrors}
                        message={message}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        styles={styles}
                        t={t}
                        handleSelectPastTestResultTeacher={handleSelectPastTestResultTeacher}
                      />
                    </View>
                  )}
                </View>


                {!!selectedTest?.id && (
                  <View style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginTop: 20,
                    gap: 12,
                  }}>
                    {/* Preview button */}
                    <TouchableOpacity
                      onPress={() => setShowTeacherPreview(true)}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingVertical: 10,
                        paddingHorizontal: 18,
                        borderRadius: 10,
                        backgroundColor: "#0d9488",
                        shadowColor: "#0d9488",
                        shadowOffset: { width: 0, height: 3 },
                        shadowOpacity: 0.2,
                        shadowRadius: 6,
                        elevation: 3,
                      }}
                    >
                      <MaterialCommunityIcons
                        name="eye-outline"
                        size={18}
                        color="#ffffff"
                        style={{ marginRight: 6 }}
                      />
                      <Text style={{
                        color: "#ffffff",
                        fontWeight: "600",
                        fontSize: 14,
                      }}>
                        Preview Test
                      </Text>
                    </TouchableOpacity>

                    {/* Delete button (unchanged logic) */}
                    <TouchableOpacity
                      onPress={handleDeleteTest}
                      disabled={deletingTestId === selectedTest.id}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingVertical: 10,
                        paddingHorizontal: 18,
                        borderRadius: 10,
                        backgroundColor: deletingTestId === selectedTest.id ? "#fca5a5" : "#dc2626",
                        opacity: deletingTestId === selectedTest.id ? 0.7 : 1,
                        shadowColor: deletingTestId === selectedTest.id ? "transparent" : "#dc2626",
                        shadowOffset: { width: 0, height: 3 },
                        shadowOpacity: 0.2,
                        shadowRadius: 6,
                        elevation: deletingTestId === selectedTest.id ? 0 : 3,
                      }}
                    >
                      <MaterialCommunityIcons
                        name={deletingTestId === selectedTest.id ? "loading" : "delete-outline"}
                        size={18}
                        color="#ffffff"
                        style={{ marginRight: 6 }}
                      />
                      <Text style={{
                        color: "#ffffff",
                        fontWeight: "600",
                        fontSize: 14,
                      }}>
                        {deletingTestId === selectedTest.id ? "Deleting…" : "Delete Test"}
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}


                {selectedTest?.id ? (  /* <-- ADD THIS WHOLE BLOCK BDD 10/23/2025*/
                  <View style={{ paddingHorizontal: 10, marginTop: 8 }}>
                    <PublishShareTestCard
                      testId={selectedTest.id}
                      isPublished={!!testDetails.is_published}
                      onChangePublished={(v) => setTestDetails(prev => ({ ...prev, is_published: !!v }))}
                      selectedClassId={selectedClassId}
                      setSelectedClassId={setSelectedClassId}
                      teacherClasses={teacherClasses}
                      shareTestWithClass={shareTestWithClass}
                      expanded={publishShareExpanded}
                      setExpanded={setPublishShareExpanded}
                      showNotification={showNotification}
                      fetchWithAuth={fetchWithAuth}
                      t={t}
                    />
                  </View>
                ) : null}

                </View>

                {(quiz.length > 0 || (selectedTest?.questions?.length ?? 0) > 0) && (() => { // BDD 10/27/2025
                  const existing = selectedTest?.questions || [];
                  const fresh = quiz.filter(q => !existing.some(e => e.question_id === q.question_id));
                  const visible = [...existing, ...fresh];

                  const total = countByDifficulty(visible);
                  const picked = countSelectedByDifficulty(visible, selectedQuestionIds);

                  const Pill = ({label, sel, tot}) => (
                    <View style={{flexDirection:"row", alignItems:"center", marginRight:10}}>
                      <Text style={{fontWeight:"600"}}>{label}</Text>
                      <Text style={{marginLeft:6}}>{sel}/{tot}</Text>
                    </View>
                  );

                  return (
                    <View style={{ paddingHorizontal:10, marginTop:8 }}>
                      <View style={{ flexDirection:"row", alignItems:"center", flexWrap:"wrap" }}>
                        <Text style={{ fontWeight:"600", marginRight:10 }}>Selected / Total:</Text>
                        <Pill label="E" sel={picked.easy}      tot={total.easy} />
                        <Pill label="M" sel={picked.medium}    tot={total.medium} />
                        <Pill label="D" sel={picked.difficult} tot={total.difficult} />
                        {total.unknown > 0 && <Pill label="?" sel={picked.unknown} tot={total.unknown} />}
                      </View>

                      <View style={{ flexDirection:"row", marginTop:6, flexWrap:"wrap" }}>
                        <Button
                          mode="text"
                          onPress={() => toggleSelectByDifficulty(visible, "easy", setSelectedQuestionIds)}
                        >
                          Toggle Easy
                        </Button>
                        <Button
                          mode="text"
                          onPress={() => toggleSelectByDifficulty(visible, "medium", setSelectedQuestionIds)}
                          style={{ marginLeft:6 }}
                        >
                          Toggle Medium
                        </Button>
                        <Button
                          mode="text"
                          onPress={() => toggleSelectByDifficulty(visible, "difficult", setSelectedQuestionIds)}
                          style={{ marginLeft:6 }}
                        >
                          Toggle Difficult
                        </Button>
                      </View>
                    </View>
                  );
                })()}


                {(quiz.length > 0 || (selectedTest?.questions?.length ?? 0) > 0) && (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      paddingHorizontal: 10,
                      paddingVertical: 6,
                      justifyContent: "space-between",
                    }}
                  >
                    {/* left side: view mode toggle */}
                    <TouchableOpacity
                      onPress={() => setCompactView(!compactView)}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: "#e5e7eb",
                        borderRadius: 6,
                        paddingHorizontal: 10,
                        paddingVertical: 6,
                      }}
                    >
                      <MaterialCommunityIcons
                        name={compactView ? "view-agenda-outline" : "format-align-left"}
                        size={16}
                        color="#111827"
                      />
                      <Text style={{ marginLeft: 6, fontSize: 12, color: "#111827", fontWeight: "500" }}>
                        {compactView ? "Expanded view" : "Compact view"}
                      </Text>
                    </TouchableOpacity>

                    {/* right side: clear selection */}
                    <Button mode="text" onPress={clearAllPicked}>
                      Clear Selection
                    </Button>
                  </View>
                )}

                {quiz.length > 0 && (
                  <View style={{ padding: 10 }}>

                    {/* 📘 Existing Test Questions */}
                    {selectedTest && selectedTest.questions?.length > 0 && (
                      <>
                        <Text
                          style={[
                            styles(isDarkMode).sectionTitle,
                            { marginTop: 10 }
                          ]}
                        >
                          📘 {t("Test Questions")}
                        </Text>

                        {selectedTest.questions.map((question, index) => (
                          <View
                            key={`existing-${index}`}
                            style={{
                              marginBottom: 8,
                              backgroundColor: "#E6F0FF", // light blue block like before
                              borderRadius: 8,
                              padding: 4,
                            }}
                          >
                            {renderQuestionBlock(question, index, compactView)}
                          </View>
                        ))}
                      </>
                    )}

                    {/* ➕ Newly Fetched Questions */}
                    {quiz.filter(
                      (q) =>
                        !selectedTest?.questions?.some(
                          (existing) => existing.question_id === q.question_id
                        )
                    ).length > 0 && (
                      <>
                        <Text
                          style={[
                            styles(isDarkMode).sectionTitle,
                            { marginTop: 20 }
                          ]}
                        >
                          {/** optional heading text here if you want */}
                        </Text>

                        {quiz
                          .filter(
                            (q) =>
                              !selectedTest?.questions?.some(
                                (existing) => existing.question_id === q.question_id
                              )
                          )
                          .map((question, index) => (
                            <View
                              key={`fetched-${index}`}
                              style={{
                                marginBottom: 8,
                                backgroundColor: "#FFF9E6", // light yellow block like before
                                borderRadius: 8,
                                padding: 4,
                              }}
                            >
                              {renderQuestionBlock(question, index, compactView)}
                            </View>
                          ))}
                      </>
                    )}
                  </View>
                )}

                <TeacherTestPreview
                  visible={showTeacherPreview}
                  onClose={() => setShowTeacherPreview(false)}
                  testDetails={{
                    ...testDetails,
                    // teacher_email: we don't store that on testDetails yet, but
                    // selectedTest has teacher_email from /tests/manage in your code.
                    teacher_email: selectedTest?.teacher_email || testDetails.teacher_email,
                  }}
                  quiz={quiz}           // <- same array you're already using to render questions
                  // isDarkMode={isDarkMode}
                  isDarkMode={false}   // <- force print-friendly mode
                  styles={styles}
                />

                </ScrollView>
            </View>
        </View>

    </View>
);
};
// Add banner styles
// BDD the following should be kept in alphabetical order for ease of maintainance
const styles = (isDarkMode) => StyleSheet.create({
        activeItem: {
            color: "#AB274F",  // Amaranth Purple
            // fontWeight: "bold",
            // textDecorationLine: "underline"
        },
        answerText: {
            color: isDarkMode ? "#f1f5f9" : "#333",
            paddingTop: 4
        },
        assessmentCard: {
            marginVertical: 10,
            padding: 15,
            borderRadius: 10,
            backgroundColor: isDarkMode ? "#1e293b" : "#FFF",
            shadowColor: "#000",
            shadowOpacity: 0.08,
            shadowRadius: 6,
            elevation: 4
        },
        assessmentTitle: {
            fontSize: 16,
            fontWeight: "bold",
            color: isDarkMode ? "#f1f5f9" : "#222",
            marginBottom: 5
        },
        assessmentScore: {
            fontSize: 14,
            fontWeight: "600",
            color: "#007BFF",
            marginBottom: 5
        },
        assessmentMeta: {
            fontSize: 12,
            color: isDarkMode ? "#94a3b8" : "#666"
        },
        adaptiveLearningText: {
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
            color: "blue"
        },
        badgeItem: {
            flexDirection: 'row',
            alignItems: 'center',
            padding: 10,
            marginVertical: 5,
            backgroundColor: isDarkMode ? "#1e293b" : "#f5f5f5",
            borderRadius: 8,
        },
        badgeText: {
            fontSize: 16,
            fontWeight: 'bold',
            color: isDarkMode ? "#f1f5f9" : "#333",
        },
        banner: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            backgroundColor: isDarkMode ? '#1e293b' : '#f0f2f5',
            color: isDarkMode ? '#f1f5f9' : '#121212',
            padding: '10px',
            textAlign: 'center',
            fontSize: '16px',
            zIndex: 9999,
        },
        bannerText: {
            color: isDarkMode ? '#f1f5f9' : '#000',
            fontSize: 16,
        },
        bottomBar: {
            flexDirection: "row",
            alignItems: "center",
            padding: 10,
            backgroundColor: isDarkMode ? "#1e293b" : "#fff",
            width: "100%",
            height: 60,
        },
        button: {
            padding: 10,
            borderRadius: 10,
            alignItems: "center",
            justifyContent: "center",
            marginRight: 10,  // Space before the mic button
        },
        chatCard: {
            backgroundColor: isDarkMode ? "#1e293b" : "#e3f2fd",
            padding: 10,
            borderRadius: 8,
            marginBottom: 12,
            borderLeftWidth: 5,
            borderLeftColor: isDarkMode ? "#70a1ff" : "#0077b6",
        },
        chapterContainer: {
            marginLeft: 15,
            marginVertical: 4,
        },
        chapterTitle: {
            fontSize: 14,
            fontWeight: '500',
            paddingVertical: 2,
            color: isDarkMode ? '#94a3b8' : '#444',
        },
        topicContainer: {
            marginLeft: 18,
            marginVertical: 4,
        },
        topicTitleItem: {
            fontSize: 12,
            paddingVertical: 3,
            paddingLeft: 15,
            color: isDarkMode ? '#94a3b8' : '#16a',
        },
        topicTitle: {
            fontSize: 13,
            fontWeight: '500',
            paddingVertical: 2,
            color: isDarkMode ? '#94a3b8' : '#444',
        },
        container: {
            flex: 1,
            backgroundColor: isDarkMode ? "#0f172a" : "#f0f2f5"
        },
        contentItem: {
            fontSize: 12,
            paddingVertical: 3,
            paddingLeft: 15,
            color: isDarkMode ? '#94a3b8' : '#16a',
            textDecorationLine: 'underline',
        },
        contentSection: {
            marginLeft: 8,
            marginTop: 4,
            marginBottom: 8,
        },
        contentWrapper: {
            flex: 1,
            flexDirection: "row",
            width: "100%"
        },
        correctAnswer: {
            backgroundColor: "#D4EDDA",  // Γ£à Light green for correct
            borderColor: "#28A745",
        },

        errorContainer: {
            marginVertical: 10,
            padding: 5,
            backgroundColor: "#fdd", // light red background for errors
            borderRadius: 4,
          },
          errorText: {
            color: "red",
            fontSize: 14,
          },

        header: {
            height: 60,
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            padding: 10,
            backgroundColor: isDarkMode ? "#1e1b4b" : "#0077b6",
        },
        headerBtn: {
            alignItems: "center",
            justifyContent: "center",
            paddingHorizontal: 10,
            paddingVertical: 6,
            borderRadius: 8,
            minWidth: 60,
        },
        headerBtnActive: {
            backgroundColor: "rgba(255,255,255,0.25)",
        },
        headerBtnLabel: {
            color: "#fff",
            fontSize: 10,
            marginTop: 2,
            fontWeight: "500",
        },
        headerLeft: {
            flexDirection: "row",
            alignItems: "center"
        },
        headerSide: {
            flex: 1  // Takes up space on the left to push the center content
        },
        headerCenter: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            flex: 2  // Center content takes up more space
        },
        // headerRight: {
        //     flexDirection: "row",
        //     alignItems: "center",
        //     justifyContent: "flex-end",
        //     flex: 1  // Ensures content sticks to the right
        // },
        headerRight: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 15,  // 🆕 Adds space between items dynamically
            flex: 1,
        },
        languageButton: {
            paddingHorizontal: 10,
            paddingVertical: 5,
            backgroundColor: "rgba(255, 255, 255, 0.2)", 
            borderRadius: 5,
        },
        
        languageText: {
            color: "white",
            fontSize: 14,
        },
        
        username: {
            color: "white",
            fontSize: 14,
            fontWeight: "bold",
            marginLeft: 15,  // 🆕 Space between language & user name
        },
        
        logoutButton: {
            marginLeft: 15,  // 🆕 Space between user name & logout icon
            padding: 5,
        },
        inputBox: {
            flex: 1,
            padding: 8,
            backgroundColor: isDarkMode ? "#1e293b" : "#fff",
            color: isDarkMode ? "#f1f5f9" : "#000",
            borderRadius: 5
        },
        leaderboardItem: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 10,
            marginVertical: 5,
            backgroundColor: isDarkMode ? "#1e293b" : "#f5f5f5",
            borderRadius: 8,
            shadowColor: "#000",
            shadowOpacity: 0.08,
            shadowRadius: 4,
            elevation: 2,
        },
        leaderboardName: {
            fontSize: 16,
            flex: 1,
            textAlign: 'center',
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        leaderboardRank: {
            fontSize: 16,
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        leaderboardScore: {
            fontSize: 16,
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        learningPathTitle: {
            fontSize: 18,
            fontWeight: 'bold',
            marginVertical: 10,
            paddingHorizontal: 10,
            color: isDarkMode ? '#f1f5f9' : '#333',
        },
        levelContainer: {
            marginBottom: 15,
            paddingHorizontal: 10,
        },
        levelTitle: {
            fontSize: 16,
            fontWeight: 'bold',
            marginBottom: 8,
            color: isDarkMode ? '#f1f5f9' : '#222',
        },
        linkText: {
            color: "#0077b6",
            marginVertical: 2
        },
        loadingText: {
            fontSize: 18,
            fontWeight: "bold",
            color: "#0077b6", // A modern blue color
            textAlign: "center",
            fontFamily: "monospace",
        },
        logo: {
            width: 50,
            height: 50,
            marginRight: 10
        },
        mainContent: {
            flex: 1,
            padding: 10,
            minHeight: 0
        },
        optionText: {
            fontSize: 16,
            fontWeight: "500",
            color: isDarkMode ? "#f1f5f9" : "#222",
        },

        profileIcon: {
            width: 40,
            height: 40,
            borderRadius: 20,
            backgroundColor: isDarkMode ? "#334155" : "#fff",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 15,
        },
        profileText: {
            fontSize: 16,
            fontWeight: "bold",
            color: "#007BFF",
        },
        modalBackground: {
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay
        },
        
        modalBox: {
            width: "33%",
            backgroundColor: isDarkMode ? "#1e293b" : "#fff",
            padding: 20,
            borderRadius: 10,
        },
        
        inputContainer: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 10,
        },
        
        modalTitle: {
            fontSize: 18,
            fontWeight: "bold",
            marginBottom: 10,
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        input: {
            width: "60%", // Make input box wider
            borderWidth: 1,
            borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#ccc",
            backgroundColor: isDarkMode ? "#334155" : "#fff",
            color: isDarkMode ? "#f1f5f9" : "#000",
            padding: 10,
            borderRadius: 5,
        },
        label: {
            width: "40%",  // Ensure labels are aligned properly
            fontSize: 16,
            fontWeight: "500",
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        modalButtons: {
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 15,
        },
        
        modalButton: {
            flex: 1,
            backgroundColor: "#4CAF50",
            padding: 12,
            borderRadius: 5,
            alignItems: "center",
            marginHorizontal: 5, // Ensure equal spacing
        },
        
        modalButtonText: {
            color: "#fff",
            fontSize: 16,
            fontWeight: "bold",
        },
        modalBackgroundSL: {
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // ✅ Dark transparent background
        },
        modalBoxSL: {
            width: "80%",
            backgroundColor: isDarkMode ? "#1e293b" : "#FFF",
            padding: 20,
            borderRadius: 10,
            alignItems: "center",
        },
        modalTitleSL: {
            fontSize: 18,
            fontWeight: "bold",
            marginBottom: 10,
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        languageItemSL: {
            fontSize: 16,
            padding: 10,
            textAlign: "center",
            borderBottomWidth: 1,
            borderBottomColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#ddd",
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        modalCloseSL: {
            marginTop: 20,
            backgroundColor: "#ff4444",
            padding: 10,
            borderRadius: 5,
        },
        languageList: {
            width: "100%",
            maxHeight: 300, // Allows scrolling if too many languages
        },
        
        listContent: {
            alignItems: "center",
        },
        
        languageItem: {
            fontSize: 16,
            padding: 10,
            textAlign: "center",
            width: "100%",
            borderBottomWidth: 1,
            borderBottomColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#ccc",
            color: isDarkMode ? "#f1f5f9" : "#000",
        },
        
        modalClose: {
            marginTop: 15,
            padding: 10,
            backgroundColor: "#d9534f",
            borderRadius: 5,
        },
        modalSave: {
            backgroundColor: "#4CAF50",
            padding: 10,
            borderRadius: 5,
        },
        closeText: {
            color: "white",
            fontSize: 16,
            fontWeight: "bold",
        },
        quizCardContainer: {
            marginVertical: 15, // Add spacing between questions
            padding: 20,
            borderRadius: 12,
            backgroundColor: isDarkMode ? "#1e293b" : "#FFF",
            shadowColor: "#000",
            shadowOpacity: 0.08,
            shadowRadius: 6,
            elevation: 4,
        },
        quizOption: {
            padding: 12,
            marginVertical: 6,
            borderRadius: 8,
            backgroundColor: isDarkMode ? "#334155" : "#F8F9FA",
            borderWidth: 1,
            borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#ddd",
        },
        quizQuestion: {
            fontSize: 18,
            fontWeight: "bold",
            marginBottom: 10,
            color: isDarkMode ? "#f1f5f9" : "#222",
        },
        resizer: {
          width: 6,
          alignSelf: "stretch",
          backgroundColor: isDarkMode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
          cursor: Platform.OS === "web" ? "col-resize" : "default",
          userSelect: "none",
          touchAction: "none",
        },
        resizerHandle: {
          flex: 1,
        },
        sectionTitle: {
            fontSize: 12,
            fontWeight: '600',
            marginVertical: 2,
            color: isDarkMode ? '#64748b' : '#666',
        },
        sidebar: {
            width: "25%",
            height: "100%",
            backgroundColor: isDarkMode ? "#1e293b" : "#fff",
            padding: 10
        },
        solutionButton: {
            marginTop: 10,
            padding: 10,
            borderRadius: 8,
            backgroundColor: "#007BFF",
            alignItems: "center",
        },
        solutionButtonText: {
            color: "white",
            fontWeight: "bold",
            fontSize: 16,
        },
        solutionText: {
            marginTop: 10,
            padding: 10,
            borderRadius: 8,
            backgroundColor: "#FFF3CD",
            borderColor: "#FFC107",
            borderWidth: 1,
            fontSize: 16,
        },
        statusContainer: {
            height: 40,  // Ensures space for status text at all times
            justifyContent: "center",  // Aligns vertically in the frame
            marginBottom: 10, // Space below the status message
            paddingLeft: 10,  // Γ£à Adds padding for left alignment
            alignItems: "flex-start",  // Γ£à Left-aligns the text
            width: "100%",  // Ensures it spans the entire width
        },
        subjectContainer: {
            marginLeft: 10,
            marginBottom: 8,
        },
        subjectTitle: {
            fontSize: 15,
            fontWeight: '600',
            paddingVertical: 4,
            color: isDarkMode ? '#f1f5f9' : '#333',
        },
        tab: {
            flex: 1,
            paddingVertical: 10,
            alignItems: 'center',
        },
        tabContainer: {
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderBottomColor: isDarkMode ? 'rgba(148,163,184,0.15)' : '#ddd',
        },
        tabText: {
            color: isDarkMode ? '#f1f5f9' : '#333',
            fontWeight: '500',
        },
        teacherHeader: {
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: isDarkMode ? "#1e1b4b" : "#0077b6",
            paddingHorizontal: 10,
            paddingVertical: 8,
            gap: 10,
        },
        title: {
            fontSize: 20,
            fontWeight: "bold",
            color: "#fff"
        },
        userSection: {
            flexDirection: "row",
            alignItems: "right",
            gap: 10
        },

        // username: {
        //     color: "white",
        //     fontSize: 16
        // },

        wrongAnswer: {
            backgroundColor: "#F8D7DA",  // Γ¥î Light red for incorrect
            borderColor: "#DC3545",
        },

        container_TD: {
            flex: 1,
            backgroundColor: isDarkMode ? "#0f172a" : "#f8f8f8",
            padding: 10,
        },
        scrollContainer_TD: {
            paddingBottom: 20,
        },
        header_TD: {
            fontSize: 22,
            fontWeight: "bold",
            marginBottom: 10,
            textAlign: "center",
            color: isDarkMode ? "#f1f5f9" : "#333",
        },
        backButton_TD: {
            backgroundColor: "#007BFF",
            padding: 10,
            borderRadius: 5,
            marginBottom: 10,
            alignItems: "center",
        },
        backButtonText_TD: {
            color: "#fff",
            fontSize: 16,
            fontWeight: "bold",
        },        
    });

export default CreateTestQuestionsPageNew2;
